var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 98,
    viewBox: "0 0 115 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_2807)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1027 38.7686C43.8045 37.0992 47.6189 36.5979 50.4418 37.7302C52.7108 38.6388 53.5817 40.6081 52.3445 42.0269C51.6433 42.8281 50.4775 43.392 49.1375 43.6695C48.5077 43.7993 48.4363 44.3006 49.0125 44.502L60.4513 48.4272L67.2404 41.7584C67.6781 41.3287 68.8082 41.3914 69.0806 41.8703C69.5228 42.6446 70.4653 43.3249 71.8275 43.7366C74.3824 44.5064 77.5805 44.0096 79.1035 42.6043C80.7785 41.0602 79.9031 39.0282 77.1963 38.0972C75.9814 37.681 74.6102 37.5602 73.3283 37.6989C72.4752 37.7884 71.8275 37.2513 72.2697 36.8172L79.0589 30.1484L49.669 20.0646C48.3827 19.626 46.7301 19.8677 45.9797 20.6062L28.7344 37.5467L40.191 41.4764C40.7628 41.6733 41.4819 41.4003 41.3747 41.0199C41.1603 40.268 41.3836 39.4758 42.0983 38.7731L42.1027 38.7686Z",
    fill: "url(#paint0_linear_2164_2807)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3344 37.6944C74.6163 37.5556 75.9875 37.6765 77.2024 38.0927C77.6938 38.2628 78.127 38.4687 78.4933 38.7014L79.065 38.142V30.1394L72.2759 36.8082C71.8337 37.2423 72.4813 37.7794 73.3344 37.6899V37.6944Z",
    fill: "url(#paint1_linear_2164_2807)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9153 41.2614C79.8215 41.7224 79.5625 42.1789 79.1069 42.5996C77.5838 44.005 74.3858 44.5018 71.8309 43.732C70.4686 43.3202 69.5217 42.6399 69.084 41.8656C68.8115 41.3867 67.6859 41.3241 67.2438 41.7537L60.4546 48.4225L49.0158 44.4973C48.4352 44.3004 48.5066 43.7991 49.1409 43.6649C50.4764 43.3874 51.6466 42.8234 52.3478 42.0223C53.5851 40.608 52.7141 38.6342 50.4451 37.7256C47.6267 36.5933 43.8078 37.0945 42.1061 38.764C41.3914 39.4667 41.1681 40.2633 41.3825 41.0108C41.4897 41.3912 40.7706 41.6642 40.1989 41.4673L28.7422 37.5376V45.5402L40.1989 49.4699C40.7706 49.6668 41.4897 49.3938 41.3825 49.0133C41.1681 48.2614 41.3914 47.4692 42.1061 46.7665C43.4639 45.4328 46.1751 44.8464 48.6496 45.2448V51.9941C48.5781 52.1777 48.6898 52.388 49.0158 52.4999L60.4546 56.4251L67.2438 49.7563C67.6815 49.3266 68.8115 49.3893 69.084 49.8682C69.5262 50.6425 70.4686 51.3228 71.8309 51.7346C74.3858 52.5044 77.5838 52.0076 79.1069 50.6022C79.8081 49.9532 80.0583 49.2237 79.9153 48.521V41.2659V41.2614Z",
    fill: "url(#paint2_linear_2164_2807)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2651 49.4744V41.4719C67.881 41.4406 67.4701 41.5301 67.2423 41.7539L60.4531 48.4227V56.4252L67.2423 49.7564C67.4701 49.5326 67.881 49.4431 68.2651 49.4744Z",
    fill: "url(#paint3_linear_2164_2807)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4908 49.5999C67.4908 49.5999 67.4589 49.6089 67.4453 49.6179C67.4589 49.6089 67.4771 49.6089 67.4908 49.5999Z",
    fill: "url(#paint4_linear_2164_2807)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0158 44.502C48.4352 44.305 48.5066 43.8038 49.1409 43.6695C50.4764 43.392 51.6466 42.828 52.3478 42.0269C53.5851 40.6126 52.7141 38.6388 50.4451 37.7302C47.6267 36.6023 43.8078 37.0991 42.1061 38.7686C41.3914 39.4713 41.1681 40.2679 41.3825 41.0154C41.4897 41.3958 40.7706 41.6688 40.1989 41.4719L28.7422 37.5422V45.5448L40.1989 49.4745C40.7706 49.6714 41.4897 49.3984 41.3825 49.0179C41.1681 48.266 41.3914 47.4738 42.1061 46.7711C43.4639 45.4374 46.1751 44.8511 48.6496 45.2449V51.9943C48.5781 52.1778 48.6898 52.3882 49.0158 52.5L60.4546 56.4252V48.4227L49.0158 44.4975V44.502Z",
    fill: "url(#paint5_linear_2164_2807)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9169 48.5212V41.2661C79.8231 41.7271 79.564 42.1836 79.1084 42.6044C77.5853 44.0097 74.3873 44.5065 71.8324 43.7367C70.4701 43.3249 69.5232 42.6446 69.0855 41.8703C68.8845 41.5212 68.2324 41.3959 67.7188 41.5212C67.8929 41.4809 68.0805 41.4675 68.2681 41.4809V49.4835C68.6255 49.5148 68.9515 49.6446 69.0855 49.8729C69.5277 50.6472 70.4701 51.3275 71.8324 51.7393C74.3873 52.5091 77.5853 52.0123 79.1084 50.6069C79.8097 49.9579 80.0598 49.2284 79.9169 48.5257V48.5212Z",
    fill: "url(#paint6_linear_2164_2807)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4432 41.615C67.3673 41.6553 67.3003 41.7 67.2422 41.7537C67.3003 41.7 67.3673 41.6508 67.4432 41.615Z",
    fill: "url(#paint7_linear_2164_2807)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6976 41.5212C67.6262 41.5391 67.5547 41.566 67.4922 41.5973C67.5592 41.566 67.6262 41.5391 67.6976 41.5212Z",
    fill: "url(#paint8_linear_2164_2807)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3681 41.1899L28.7422 37.5422L39.3681 41.1899Z",
    fill: "url(#paint9_linear_2164_2807)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.198 49.4744L39.3672 49.188L40.198 49.4744C40.2694 49.5013 40.3454 49.5147 40.4213 49.5281C40.3454 49.5192 40.2694 49.5013 40.198 49.4744Z",
    fill: "url(#paint10_linear_2164_2807)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4609 49.5281C40.5235 49.537 40.5905 49.537 40.653 49.537C40.5905 49.537 40.5279 49.537 40.4609 49.5281Z",
    fill: "url(#paint11_linear_2164_2807)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0652 49.4521C41.0415 49.4616 41.0652 49.4521 41.0652 49.4521V49.4521Z",
    fill: "url(#paint12_linear_2164_2807)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.638 52.0525C48.629 52.0883 48.6335 52.1241 48.638 52.1554V52.0525Z",
    fill: "url(#paint13_linear_2164_2807)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6333 44.1797C48.5708 43.9738 48.7494 43.75 49.138 43.6695C50.4735 43.392 51.6437 42.828 52.345 42.0269C53.5822 40.6126 52.7112 38.6388 50.4422 37.7302C47.6238 36.6023 43.805 37.0991 42.1032 38.7686C41.3886 39.4713 41.1652 40.2679 41.3796 41.0154C41.4332 41.1989 41.2858 41.3555 41.0625 41.4495V49.4476C41.1295 49.4118 41.4422 49.2373 41.3796 49.0179C41.1652 48.266 41.3886 47.4738 42.1032 46.7711C43.461 45.4374 46.1633 44.8555 48.6333 45.2449V44.1797Z",
    fill: "url(#paint14_linear_2164_2807)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2484 37.0274C72.2484 37.0274 72.2663 37.0051 72.2752 36.9916L79.0644 30.3228L78.6624 30.1841L72.2752 36.459C72.0832 36.647 72.0966 36.8574 72.2484 37.0274Z",
    fill: "url(#paint15_radial_2164_2807)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1102 42.2461C77.5872 43.6515 74.3891 44.1483 71.8342 43.3785C70.472 42.9667 69.525 42.2864 69.0873 41.5121C68.8149 41.0332 67.6893 40.9705 67.2471 41.4002L60.458 48.069L49.0192 44.1438C48.912 44.108 48.836 44.0588 48.7735 44.0051C48.5189 44.2109 48.5859 44.5287 49.0192 44.6764L60.458 48.6016L67.2471 41.9328C67.6848 41.5031 68.8149 41.5658 69.0873 42.0447C69.5295 42.819 70.472 43.4993 71.8342 43.9111C74.3891 44.6809 77.5872 44.1841 79.1102 42.7787C79.7758 42.1655 80.0348 41.4718 79.9366 40.8049C79.8651 41.3017 79.6016 41.7941 79.1102 42.2461Z",
    fill: "url(#paint16_radial_2164_2807)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3244 40.9169C41.1413 41.1452 40.6277 41.266 40.1989 41.1183L29.1442 37.3274L28.7422 37.7213L40.1989 41.6509C40.7706 41.8479 41.4897 41.5748 41.3825 41.1944C41.3557 41.1049 41.3378 41.0109 41.3244 40.9169Z",
    fill: "url(#paint17_radial_2164_2807)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8923 40.5184C53.0576 39.3279 52.142 38.0523 50.4447 37.3765C47.6263 36.2486 43.8074 36.7454 42.1057 38.4148C41.4759 39.0325 41.2302 39.7217 41.324 40.3886C41.391 39.8963 41.6411 39.404 42.1057 38.9474C43.8074 37.278 47.6218 36.7767 50.4447 37.9091C51.8874 38.4864 52.7628 39.4979 52.8923 40.5184Z",
    fill: "url(#paint18_radial_2164_2807)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M73.8724 50.2263C73.1891 50.2173 72.6575 47.9392 72.6888 45.1329C72.7201 42.3266 73.3007 40.0619 73.9886 40.0664C74.6764 40.0709 75.2035 42.3535 75.1722 45.1598C75.1409 47.966 74.5603 50.2307 73.8724 50.2263Z",
    fill: "url(#paint19_radial_2164_2807)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M47.1693 42.4028C46.4859 42.3938 45.9544 40.1157 45.9857 37.3094C46.017 34.5032 46.5976 32.2385 47.2855 32.2429C47.9733 32.2474 48.5004 34.53 48.4691 37.3363C48.4378 40.1425 47.8572 42.4072 47.1693 42.4028Z",
    fill: "url(#paint20_radial_2164_2807)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2631 63.1433C27.8779 61.7648 27.9717 59.5001 30.5489 58.2066C32.6214 57.1682 36.1321 57.1817 38.2001 58.2379C39.3748 58.8377 40.0314 59.6344 40.1743 60.4534C40.2413 60.8428 41.0631 61.0084 41.5366 60.7354L50.8851 55.3242L41.3713 49.8191C40.755 49.4611 41.1391 48.8479 42.0056 48.8166C43.4081 48.7673 44.7748 48.4138 45.7977 47.7514C47.7094 46.5161 47.6513 44.596 45.6682 43.3831C43.4929 42.0538 39.875 42.0225 37.6641 43.3025C36.6725 43.8754 36.1366 44.6139 36.0517 45.3703C35.9981 45.8716 34.9351 46.0954 34.3187 45.7373L24.8049 40.2322L0.783892 54.1292C-0.265745 54.7379 -0.261278 55.7226 0.797292 56.3358L24.9657 70.3179L34.3276 64.9023C34.7966 64.6337 34.5107 64.1593 33.8497 64.1235C32.541 64.0519 31.268 63.7251 30.2631 63.1433Z",
    fill: "url(#paint21_linear_2164_2807)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7968 47.7514C44.7784 48.4093 43.4072 48.7674 42.0047 48.8166C41.1382 48.8479 40.7585 49.4611 41.3704 49.8192L47.1591 53.167V45.9387C47.0474 46.5966 46.5963 47.2367 45.7923 47.7514H45.7968Z",
    fill: "url(#paint22_linear_2164_2807)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5333 60.731C41.0598 61.0041 40.238 60.8384 40.171 60.4491C40.0281 59.63 39.3715 58.8333 38.1968 58.2336C36.1243 57.1773 32.6181 57.1639 30.5456 58.2023C27.9684 59.4957 27.8746 61.7604 30.2597 63.139C31.2647 63.7208 32.5377 64.0475 33.8464 64.1191C34.2528 64.1415 34.5119 64.3295 34.5476 64.5309V64.5354C34.5476 64.5443 34.5476 64.5488 34.5476 64.5578V65.435C35.8831 65.4618 37.2052 65.7259 38.1923 66.2317C39.367 66.8314 40.0236 67.6281 40.1665 68.4471C40.2335 68.8365 41.0554 69.0021 41.5288 68.7291L50.4842 63.5462L50.8773 63.4612V55.3154L41.5288 60.7266L41.5333 60.731Z",
    fill: "url(#paint23_linear_2164_2807)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0.795044 56.3358C0.276925 56.0359 0.0133996 55.6421 0 55.2527V63.0852H0.0133996C-0.058065 63.5283 0.200994 63.9937 0.795044 64.3384L24.9635 78.3205V70.3179L0.795044 56.3358Z",
    fill: "url(#paint24_linear_2164_2807)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3228 64.9024L24.9609 70.318V78.3206L34.3228 72.905C34.4702 72.8199 34.5327 72.717 34.5461 72.6096H34.5506V72.5648C34.5506 72.5559 34.5506 72.5514 34.5506 72.5424V64.5623C34.5595 64.6831 34.4925 64.8039 34.3228 64.9024Z",
    fill: "url(#paint25_linear_2164_2807)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3228 64.9024L24.9609 70.318V78.3206L34.3228 72.905C34.4702 72.8199 34.5327 72.717 34.5461 72.6096H34.5506V72.5648C34.5506 72.5559 34.5506 72.5514 34.5506 72.5424V64.5623C34.5595 64.6831 34.4925 64.8039 34.3228 64.9024Z",
    fill: "url(#paint26_linear_2164_2807)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2712 64.5756L24.9629 69.9598L0.794463 55.9777C0.423741 55.7629 0.182547 55.4988 0.070884 55.2258C-0.134577 55.7361 0.106616 56.291 0.794463 56.6894L24.9629 70.6715L34.3248 65.2559C34.6732 65.0545 34.6062 64.7367 34.2712 64.5756Z",
    fill: "url(#paint27_radial_2164_2807)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7965 47.3933C44.7781 48.0512 43.4069 48.4093 42.0044 48.4585C41.187 48.4899 40.8029 49.0359 41.2763 49.3984C41.4371 49.2731 41.6873 49.1836 42.0044 49.1702C43.4069 49.1209 44.7736 48.7674 45.7965 48.1049C46.8774 47.4067 47.3285 46.4892 47.1588 45.603C47.0382 46.252 46.5915 46.8831 45.7965 47.3933Z",
    fill: "url(#paint28_radial_2164_2807)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5326 60.3773C41.0591 60.6503 40.2373 60.4847 40.1703 60.0953C40.0274 59.2763 39.3708 58.4796 38.1961 57.8798C36.1236 56.8236 32.6174 56.8102 30.5449 57.8485C29.0397 58.6049 28.3876 59.6925 28.5796 60.7398C28.727 59.9297 29.3791 59.1465 30.5449 58.5602C32.6174 57.5218 36.1281 57.5352 38.1961 58.5915C39.3708 59.1912 40.0274 59.9879 40.1703 60.807C40.2373 61.1963 41.0591 61.3619 41.5326 61.0889L50.8811 55.6778L50.2647 55.3242L41.5281 60.3773H41.5326Z",
    fill: "url(#paint29_radial_2164_2807)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M34.1706 63.676C33.6168 63.6715 33.1969 61.3576 33.2282 58.511C33.2595 55.6645 33.7329 53.3595 34.2868 53.3684C34.8406 53.3729 35.2605 55.6868 35.2292 58.5334C35.1979 61.3799 34.7245 63.6849 34.1706 63.676Z",
    fill: "url(#paint30_radial_2164_2807)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M37.3661 63.8538C38.9679 63.1942 39.1984 60.0555 37.881 56.8432C36.5636 53.6308 34.1972 51.5615 32.5955 52.221C30.9938 52.8806 30.7633 56.0194 32.0806 59.2317C33.398 62.444 35.7644 64.5134 37.3661 63.8538Z",
    fill: "url(#paint31_radial_2164_2807)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7236 46.5696C87.1087 47.9481 87.0149 50.2128 84.4377 51.5063C82.3652 52.5446 78.8545 52.5312 76.7865 51.4749C75.6118 50.8752 74.9553 50.0785 74.8123 49.2595C74.7453 48.8701 73.9235 48.7045 73.45 48.9775L64.1016 54.3886L73.6153 59.8937C74.2317 60.2518 73.8476 60.865 72.981 60.8963C71.5786 60.9455 70.2118 61.2991 69.189 61.9615C67.2773 63.1968 67.3353 65.1169 69.3185 66.3298C71.4937 67.6591 75.1116 67.6904 77.3225 66.4104C78.3141 65.8375 78.8501 65.099 78.9349 64.3426C78.9885 63.8413 80.0516 63.6175 80.668 63.9756L90.1817 69.4807L114.203 55.5836C115.252 54.9749 115.248 53.9903 114.189 53.3771L90.0209 39.395L80.659 44.8106C80.19 45.0792 80.4759 45.5536 81.1369 45.5894C82.4456 45.661 83.7186 45.9877 84.7236 46.5696Z",
    fill: "url(#paint32_linear_2164_2807)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7236 46.5696C87.1087 47.9481 87.0149 50.2128 84.4377 51.5063C82.3652 52.5446 78.8545 52.5312 76.7865 51.4749C75.6118 50.8752 74.9553 50.0785 74.8123 49.2595C74.7453 48.8701 73.9235 48.7045 73.45 48.9775L64.1016 54.3886L73.6153 59.8937C74.2317 60.2518 73.8476 60.865 72.981 60.8963C71.5786 60.9455 70.2118 61.2991 69.189 61.9615C67.2773 63.1968 67.3353 65.1169 69.3185 66.3298C71.4937 67.6591 75.1116 67.6904 77.3225 66.4104C78.3141 65.8375 78.8501 65.099 78.9349 64.3426C78.9885 63.8413 80.0516 63.6175 80.668 63.9756L90.1817 69.4807L114.203 55.5836C115.252 54.9749 115.248 53.9903 114.189 53.3771L90.0209 39.395L80.659 44.8106C80.19 45.0792 80.4759 45.5536 81.1369 45.5894C82.4456 45.661 83.7186 45.9877 84.7236 46.5696Z",
    fill: "url(#paint33_linear_2164_2807)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4418 51.5064C87.019 50.2129 87.1083 47.9482 84.7276 46.5697C83.7226 45.9878 82.4497 45.6611 81.141 45.5895C80.7167 45.5671 80.4531 45.3657 80.4353 45.1509H80.4219V52.2717C81.8824 52.3031 83.3564 52.0524 84.4418 51.5064Z",
    fill: "url(#paint34_linear_2164_2807)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M114.982 62.4493H115V54.4468H114.982C115 54.863 114.741 55.2748 114.201 55.5881L90.1797 69.4851V77.4877L114.201 63.5906C114.741 63.2773 115 62.8656 114.982 62.4538V62.4493Z",
    fill: "url(#paint35_linear_2164_2807)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M114.982 62.4493H115V54.4468H114.982C115 54.863 114.741 55.2748 114.201 55.5881L90.1797 69.4851V77.4877L114.201 63.5906C114.741 63.2773 115 62.8656 114.982 62.4538V62.4493Z",
    fill: "url(#paint36_linear_2164_2807)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1968 61.9616C70.2151 61.3036 71.5864 60.9456 72.9889 60.8963C73.8554 60.865 74.235 60.2518 73.6231 59.8938L64.1094 54.3887V62.3912L67.8166 64.5351L67.8568 64.5217C67.6513 63.6176 68.0935 62.6732 69.2012 61.9616H69.1968Z",
    fill: "url(#paint37_linear_2164_2807)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6724 63.9757C80.3687 63.8012 79.9578 63.7654 79.6094 63.837V71.8395C79.9578 71.7679 80.3687 71.8037 80.6724 71.9783L90.1906 77.4834V69.4808L80.6724 63.9757Z",
    fill: "url(#paint38_linear_2164_2807)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.942 64.3425C78.8616 65.0944 78.3256 65.8329 77.3295 66.4103C75.1186 67.6903 71.5007 67.659 69.3255 66.3297C68.4902 65.8195 68.0034 65.1839 67.8515 64.526L67.8113 64.5394V71.9467C67.7399 72.8016 68.2446 73.6743 69.3255 74.3323C71.5007 75.666 75.1186 75.6929 77.3295 74.4128C78.3211 73.8399 78.8571 73.1015 78.942 72.3451C78.9688 72.0899 79.2546 71.9064 79.6119 71.8348V63.8323C79.2546 63.9039 78.9688 64.0874 78.942 64.3425Z",
    fill: "url(#paint39_linear_2164_2807)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M78.942 64.3425C78.8616 65.0944 78.3256 65.8329 77.3295 66.4103C75.1186 67.6903 71.5007 67.659 69.3255 66.3297C68.4902 65.8195 68.0034 65.1839 67.8515 64.526L67.8113 64.5394V71.9467C67.7399 72.8016 68.2446 73.6743 69.3255 74.3323C71.5007 75.666 75.1186 75.6929 77.3295 74.4128C78.3211 73.8399 78.8571 73.1015 78.942 72.3451C78.9688 72.0899 79.2546 71.9064 79.6119 71.8348V63.8323C79.2546 63.9039 78.9688 64.0874 78.942 64.3425Z",
    fill: "url(#paint40_linear_2164_2807)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.718 60.3145C73.9994 60.0952 74.0128 59.764 73.6198 59.5402L64.7179 54.3887L64.1016 54.7423L73.6153 60.2474C73.651 60.2697 73.6823 60.2876 73.7136 60.31L73.718 60.3145Z",
    fill: "url(#paint41_radial_2164_2807)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1346 45.9476C82.4433 46.0192 83.7163 46.3459 84.7213 46.9277C85.7128 47.5006 86.2667 48.2302 86.4052 48.9731C86.5883 47.9929 86.03 46.9725 84.7213 46.2161C83.7163 45.6343 82.4433 45.3075 81.1346 45.2359C80.9694 45.227 80.8265 45.1912 80.7148 45.1375L80.6612 45.1688C80.1922 45.4373 80.4781 45.9118 81.1391 45.9476H81.1346Z",
    fill: "url(#paint42_radial_2164_2807)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M70.4152 73.0926C69.6916 73.0836 69.1378 70.5056 69.1735 67.3368C69.2092 64.1636 69.8256 61.599 70.5492 61.6079C71.2728 61.6169 71.8266 64.1949 71.7909 67.3682C71.7552 70.5414 71.1388 73.106 70.4152 73.0971V73.0926Z",
    fill: "url(#paint43_radial_2164_2807)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M80.6725 63.6219C80.0561 63.2639 78.9931 63.4877 78.9395 63.9889C78.8591 64.7409 78.3231 65.4794 77.3271 66.0567C75.1161 67.3368 71.4982 67.3054 69.323 65.9762C68.461 65.448 67.9652 64.7901 67.8357 64.1143C67.6704 65.0273 68.1662 65.9806 69.323 66.6878C71.4982 68.0216 75.1161 68.0484 77.3271 66.7684C78.3186 66.1955 78.8546 65.457 78.9395 64.7006C78.9931 64.1993 80.0561 63.9755 80.6725 64.3336L90.1237 69.7984V69.0868L80.6725 63.6219Z",
    fill: "url(#paint44_radial_2164_2807)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M114.205 55.9417C114.884 55.5478 115.121 54.9973 114.915 54.4871C114.804 54.7601 114.571 55.0152 114.205 55.23L90.1842 69.1271L90.1172 69.0868V69.7984L90.1842 69.8387L114.205 55.9417Z",
    fill: "url(#paint45_radial_2164_2807)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8159 71.3114C69.9534 72.9226 66.0898 73.2941 63.3876 72.0722C61.2124 71.0921 60.5379 69.0959 61.9136 67.7219C62.6953 66.9431 63.9146 66.4194 65.2769 66.1867C65.9201 66.0748 66.0407 65.578 65.4824 65.3587L54.4456 61.062L47.0043 67.4936C46.5219 67.9098 45.4053 67.8069 45.1775 67.3235C44.8157 66.5358 43.9403 65.8242 42.6182 65.3676C40.1437 64.5128 36.901 64.9022 35.2394 66.2538C33.4126 67.7398 34.0871 69.7986 36.6955 70.8146C37.8658 71.2711 39.2281 71.4367 40.5189 71.3427C41.3809 71.28 41.9705 71.8395 41.4881 72.2557L34.0469 78.6873L62.396 89.7244C63.6332 90.2078 65.3082 90.0198 66.1345 89.3037L85.0369 72.9719L73.9867 68.6707C73.4328 68.4559 72.6914 68.7065 72.7584 69.087C72.8968 69.8433 72.5976 70.6266 71.8115 71.3069L71.8159 71.3114Z",
    fill: "url(#paint46_linear_2164_2807)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1345 89.3126C65.3082 90.0287 63.6332 90.2122 62.396 89.7333L34.0469 78.6962V86.6987L62.396 97.7358C63.6332 98.2192 65.3082 98.0312 66.1345 97.3151L85.0369 80.9833V72.9807L66.1345 89.3126Z",
    fill: "url(#paint47_linear_2164_2807)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5209 71.3471C39.2256 71.4411 37.8678 71.2755 36.6976 70.819C35.2147 70.2416 34.3616 69.3286 34.232 68.3752V75.9034C34.1516 76.5747 34.4375 77.2506 35.0539 77.8279L41.4946 72.2646C41.977 71.8484 41.3874 71.2889 40.5254 71.3516L40.5209 71.3471Z",
    fill: "url(#paint48_linear_2164_2807)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2732 66.1912C63.911 66.424 62.6871 66.9476 61.9099 67.7264C60.5342 69.1004 61.2087 71.0921 63.3839 72.0768C64.1253 72.4125 64.9561 72.6228 65.8092 72.7258V65.8645C65.7467 66.0122 65.568 66.142 65.2777 66.1957L65.2732 66.1912Z",
    fill: "url(#paint49_linear_2164_2807)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 69.2927C72.7701 69.3241 72.7656 69.3599 72.7656 69.3957C72.7701 69.3599 72.779 69.3241 72.7835 69.2927Z",
    fill: "url(#paint50_radial_2164_2807)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9147 67.3683C61.3252 67.9547 61.1152 68.6573 61.2358 69.3421C61.3118 68.8945 61.5306 68.4604 61.9147 68.0755C62.6964 67.2967 63.9158 66.7731 65.278 66.5403C65.8944 66.4329 66.024 65.9764 65.5416 65.7437C65.4656 65.7795 65.3808 65.8108 65.278 65.8287C63.9158 66.0614 62.6919 66.5851 61.9147 67.3639V67.3683Z",
    fill: "url(#paint51_radial_2164_2807)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6974 71.1727C37.8677 71.6292 39.2299 71.7948 40.5208 71.7008C40.9183 71.674 41.2533 71.7769 41.4588 71.9336L41.4945 71.9022C41.9769 71.486 41.3873 70.9265 40.5252 70.9892C39.23 71.0832 37.8721 70.9176 36.7019 70.4611C35.2681 69.9016 34.424 69.0288 34.2542 68.1113C34.0264 69.275 34.9019 70.47 36.7019 71.1727H36.6974Z",
    fill: "url(#paint52_radial_2164_2807)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1345 88.9547C65.3082 89.6709 63.6332 89.8544 62.396 89.3755L34.6141 78.5577L34.0469 79.05L62.396 90.0871C63.6332 90.5705 65.3082 90.3825 66.1345 89.6664L85.0369 73.3345L84.4696 73.1152L66.1345 88.9592V88.9547Z",
    fill: "url(#paint53_radial_2164_2807)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M63.4219 92.7053C63.4576 89.4649 63.8551 86.8466 64.3018 86.8511C64.7484 86.8556 65.0879 89.4873 65.0522 92.7232",
    fill: "url(#paint54_radial_2164_2807)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M36.2853 75.5231C35.8342 75.5186 35.4903 73.6433 35.5171 71.3383C35.5439 69.0333 35.928 67.1669 36.3791 67.1714C36.8303 67.1759 37.1742 69.0512 37.1474 71.3562C37.1206 73.6612 36.7365 75.5275 36.2853 75.5231Z",
    fill: "url(#paint55_radial_2164_2807)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M67.7133 88.9635C68.7942 91.5952 68.0036 94.4149 65.9535 95.2608C63.9033 96.1067 61.3619 94.6566 60.281 92.0249C59.2001 89.3931 59.9907 86.5735 62.0408 85.7275C64.0909 84.8816 66.6324 86.3318 67.7133 88.9635Z",
    fill: "url(#paint56_radial_2164_2807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2239 27.2838C91.8978 27.2838 91.5539 27.2346 91.2055 27.1361C91.1519 27.1227 91.1117 27.0824 91.0894 27.0332L90.4149 25.3771C90.2229 25.2966 90.0531 25.2115 89.8879 25.1176C89.7449 25.037 89.5975 24.9385 89.4368 24.8222L88.8382 25.5965C88.807 25.6367 88.7623 25.6591 88.7132 25.6636C88.664 25.6636 88.6149 25.6502 88.5792 25.6188C88.1325 25.225 87.7037 24.7729 87.3062 24.2716C87.2705 24.2269 87.2616 24.1732 87.2705 24.1195L87.5653 22.8752C87.2839 22.4635 87.0293 22.0293 86.8149 21.5773L85.5821 21.2058C85.5285 21.1924 85.4883 21.1521 85.4705 21.1029C85.2382 20.5076 85.0595 19.9123 84.9434 19.3305C84.9345 19.2812 84.9434 19.232 84.9747 19.1917C85.0015 19.1514 85.0461 19.1246 85.0953 19.1201L86.069 18.9948C86.0467 18.7979 86.0377 18.6233 86.0377 18.4577C86.0377 18.2697 86.0511 18.0817 86.0779 17.8759L84.9747 16.4615C84.939 16.4168 84.93 16.3586 84.9434 16.3049C85.064 15.8484 85.2471 15.4456 85.4928 15.1054C85.5241 15.0651 85.5643 15.0383 85.6134 15.0338C85.6625 15.0293 85.7117 15.0427 85.7474 15.0741L86.9355 16.0901C87.1186 15.9379 87.3241 15.817 87.5519 15.7365L87.266 14.2058C87.2571 14.1566 87.266 14.1073 87.2973 14.067C87.3285 14.0268 87.3732 13.9999 87.4223 13.9954C87.8333 13.9596 88.2799 13.9999 88.74 14.1252C88.7936 14.1387 88.8382 14.1789 88.8561 14.2282L89.5306 15.8842C89.7226 15.9647 89.8968 16.0498 90.0576 16.1438C90.2005 16.2243 90.3479 16.3228 90.5087 16.4392L91.1072 15.6649C91.1385 15.6246 91.1832 15.6022 91.2323 15.5977C91.2814 15.5933 91.3306 15.6067 91.3663 15.6425C91.813 16.0364 92.2417 16.4884 92.6393 16.9897C92.675 17.0344 92.6839 17.0881 92.675 17.1419L92.3802 18.3861C92.6616 18.7979 92.9162 19.232 93.1306 19.6841L94.3633 20.0555C94.4169 20.069 94.4571 20.1092 94.475 20.1585C94.7073 20.7537 94.8859 21.349 95.0021 21.9309C95.011 21.9801 95.0021 22.0293 94.9708 22.0696C94.944 22.1099 94.8993 22.1367 94.8502 22.1412L93.8765 22.2665C93.8944 22.4635 93.9078 22.638 93.9078 22.8036C93.9078 22.9916 93.8944 23.1841 93.8676 23.3855L94.9708 24.7998C95.0065 24.8445 95.0155 24.9027 95.0021 24.9564C94.8815 25.413 94.6983 25.8158 94.4527 26.1559C94.4214 26.1962 94.3812 26.2231 94.3321 26.2275C94.283 26.2365 94.2338 26.2186 94.1981 26.1872L93.01 25.1713C92.8269 25.3234 92.6214 25.4443 92.3936 25.5248L92.6795 27.0555C92.6884 27.1048 92.6795 27.154 92.6482 27.1943C92.6169 27.2346 92.5723 27.2614 92.5231 27.2659C92.4249 27.2748 92.3266 27.2793 92.2283 27.2793L92.2239 27.2838ZM91.3797 26.8183C91.6924 26.8989 92.005 26.9347 92.2909 26.9302L92.0139 25.4443C91.9961 25.3548 92.0541 25.2653 92.1435 25.2384C92.4249 25.1623 92.6705 25.0236 92.876 24.8177C92.943 24.755 93.0457 24.7505 93.1172 24.8087L94.274 25.7979C94.4259 25.5517 94.5465 25.2742 94.6358 24.9609L93.5415 23.56C93.5102 23.5197 93.4968 23.475 93.5058 23.4257C93.537 23.2109 93.5504 23.0095 93.5504 22.817C93.5504 22.6246 93.537 22.4053 93.5013 22.1502C93.4879 22.0517 93.5594 21.9622 93.6532 21.9532L94.609 21.8324C94.5018 21.358 94.3544 20.8746 94.1668 20.3867L92.943 20.0153C92.8939 20.0018 92.8537 19.966 92.8313 19.9213C92.608 19.4379 92.34 18.9769 92.0318 18.5427C92.0005 18.5025 91.9916 18.4488 92.005 18.3995L92.2998 17.1598C91.9693 16.7525 91.6254 16.3855 91.2636 16.0543L90.6784 16.8151C90.6204 16.8912 90.5087 16.9046 90.4328 16.8465C90.2229 16.6898 90.0442 16.569 89.8745 16.4705C89.7047 16.372 89.5261 16.287 89.3206 16.2064C89.276 16.1885 89.2402 16.1527 89.2224 16.108L88.5524 14.4609C88.2397 14.3803 87.9315 14.3445 87.6412 14.349L87.9181 15.8349C87.936 15.9245 87.8779 16.014 87.7886 16.0408C87.5072 16.1169 87.2615 16.2557 87.0561 16.4615C86.9891 16.5287 86.8864 16.5287 86.8149 16.4705L85.6581 15.4814C85.5062 15.7275 85.3856 16.005 85.2963 16.3183L86.3906 17.7237C86.4218 17.764 86.4352 17.8087 86.4263 17.858C86.395 18.0773 86.3816 18.2697 86.3816 18.4667C86.3816 18.6636 86.395 18.874 86.4308 19.1335C86.4442 19.232 86.3727 19.3215 86.2789 19.3305L85.3231 19.4513C85.4303 19.9257 85.5777 20.4091 85.7653 20.897L86.9891 21.2685C87.0382 21.2819 87.0784 21.3177 87.1008 21.3624C87.3241 21.8458 87.5921 22.3068 87.9003 22.741C87.9315 22.7812 87.9405 22.8349 87.9271 22.8842L87.6323 24.124C87.9628 24.5268 88.3067 24.8982 88.6685 25.2294L89.2536 24.4686C89.3117 24.3925 89.4234 24.3791 89.4993 24.4372C89.7047 24.5939 89.8879 24.7147 90.0576 24.8132C90.2273 24.9117 90.4015 24.9967 90.6115 25.0773C90.6561 25.0952 90.6919 25.131 90.7097 25.1757L91.3797 26.8228V26.8183Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6485 22.7589C90.4073 22.7589 90.1483 22.6828 89.8803 22.5262C89.0004 22.016 88.2812 20.7762 88.2812 19.7602C88.2812 18.9993 88.6788 18.5115 89.2907 18.5115C89.5319 18.5115 89.7909 18.5876 90.0589 18.7442C90.9388 19.2544 91.658 20.4942 91.658 21.5102C91.658 22.2711 91.2604 22.7589 90.6485 22.7589ZM89.2907 18.8695C88.8798 18.8695 88.6341 19.2052 88.6341 19.7647C88.6341 20.6643 89.2728 21.7698 90.0545 22.2218C90.2644 22.3427 90.4654 22.4053 90.644 22.4053C91.055 22.4053 91.3006 22.0697 91.3006 21.5102C91.3006 20.6106 90.6619 19.5051 89.8803 19.053C89.6703 18.9322 89.4693 18.8695 89.2907 18.8695Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9688 12.8588C75.8526 12.8588 75.7276 12.823 75.6025 12.7514L74.1107 11.8876C73.7176 11.6593 73.405 11.1267 73.405 10.6702V9.90037C73.405 9.33195 73.1816 8.64717 72.7886 8.02952C71.9935 6.77185 71.605 5.33962 71.7479 4.2028C71.8908 3.06597 72.5965 2.36328 73.5836 2.36328C73.9231 2.36328 74.2849 2.44832 74.6511 2.60944C76.5226 3.4464 78.1618 6.06916 78.1618 8.22198C78.1618 9.29167 77.7509 10.0883 77.0318 10.4061C76.6745 10.5672 76.4735 10.9432 76.4735 11.4758V12.2412C76.4735 12.4157 76.4288 12.5634 76.3395 12.6753C76.2457 12.7917 76.1117 12.8543 75.9554 12.8543L75.9688 12.8588ZM73.5926 2.71686C72.7841 2.71686 72.2303 3.28975 72.1052 4.24755C71.9712 5.30829 72.3419 6.64653 73.0923 7.83707C73.5211 8.5129 73.7623 9.26482 73.7623 9.90037V10.6702C73.7623 10.9969 74.0035 11.4132 74.2893 11.5788L75.7812 12.4426C75.8482 12.4828 75.9152 12.5052 75.9688 12.5052C76.0134 12.5052 76.0492 12.4918 76.076 12.456C76.1117 12.4112 76.1296 12.3351 76.1296 12.2456V11.4803C76.1296 10.8089 76.411 10.3032 76.8978 10.0839C77.4785 9.82428 77.8134 9.14845 77.8134 8.22198C77.8134 6.19001 76.2725 3.71942 74.5127 2.9317C74.1911 2.78847 73.8784 2.71686 73.5881 2.71686H73.5926Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4606 14.1119C75.3712 14.1119 75.2774 14.085 75.1836 14.0313L74.5271 13.6509C74.2144 13.4674 73.9688 13.0064 73.9688 12.5946V11.7397L75.9206 12.8676V13.5166C75.9206 13.9239 75.6884 14.1074 75.4606 14.1074V14.1119ZM74.3216 12.3574V12.5991C74.3216 12.8811 74.5003 13.2257 74.7013 13.3465L75.3578 13.727C75.4025 13.7538 75.4382 13.7583 75.4561 13.7583C75.5276 13.7583 75.5633 13.6374 75.5633 13.5211V13.078L74.3171 12.3574H74.3216Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1672 11.4399H74.8143V8.4636L74.7964 8.47255L73.4609 6.16309L76.3106 7.81462L75.1672 8.46807V11.4444V11.4399ZM74.4302 7.13879L75.0108 8.14582L75.5915 7.81462L74.4257 7.13879H74.4302Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7092 18.9637C58.1821 18.9637 57.6149 18.7936 57.0297 18.4534C55.0287 17.2942 53.3984 14.479 53.3984 12.174C53.3984 10.5404 54.2337 9.48413 55.529 9.48413C56.056 9.48413 56.6233 9.65421 57.2084 9.99436C59.2094 11.1536 60.8397 13.9688 60.8397 16.2738C60.8397 17.9074 60.0044 18.9637 58.7092 18.9637ZM55.529 9.83771C54.4347 9.83771 53.7513 10.7329 53.7513 12.174C53.7513 14.3626 55.3012 17.0436 57.2084 18.1446C57.731 18.449 58.2536 18.6101 58.7092 18.6101C59.8035 18.6101 60.4868 17.7149 60.4868 16.2738C60.4868 14.0852 58.9369 11.4042 57.0297 10.3032C56.5072 9.99884 55.9846 9.83771 55.529 9.83771Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4164 15.4549L57.0447 14.4389C56.9777 14.412 56.9375 14.3449 56.9375 14.2733V11.3193H57.2904V14.1569L59.5549 15.1282L59.4164 15.4549Z",
    fill: "#7C1DC9"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M105.261 41.3602C104.672 41.3602 103.984 41.0066 103.376 40.3934C103.345 40.3621 103.327 40.3128 103.336 40.2681C103.341 40.2233 103.372 40.1786 103.412 40.1562L104.551 39.5072L103.412 37.5424L102.269 38.1958C102.228 38.2182 102.179 38.2227 102.135 38.2048C102.09 38.1869 102.059 38.1511 102.045 38.1063C101.719 36.9292 101.947 35.9177 102.621 35.5328C103.269 35.1658 104.234 35.4522 105.065 36.2534L107.28 34.9868C106.999 33.8544 107.231 32.8966 107.883 32.5251C108.549 32.1447 109.558 32.4669 110.411 33.3263C110.442 33.3576 110.46 33.4068 110.451 33.4516C110.447 33.4963 110.416 33.5411 110.375 33.5635L109.236 34.2125L110.375 36.1773L111.519 35.5238C111.559 35.5015 111.608 35.497 111.653 35.5149C111.697 35.5328 111.729 35.5686 111.742 35.6134C112.068 36.7949 111.84 37.802 111.166 38.1869C110.523 38.5539 109.554 38.2674 108.723 37.4663L106.507 38.7329C106.789 39.8653 106.556 40.8231 105.904 41.1946C105.712 41.302 105.498 41.3602 105.261 41.3602ZM103.734 40.3218C104.247 40.7917 104.792 41.0603 105.261 41.0603C105.444 41.0603 105.61 41.02 105.757 40.935C106.306 40.6217 106.476 39.7444 106.19 38.7016C106.172 38.6345 106.199 38.5628 106.262 38.5315L108.674 37.153C108.732 37.1172 108.808 37.1306 108.857 37.1798C109.607 37.9362 110.474 38.2451 111.019 37.9318C111.537 37.6364 111.715 36.8442 111.501 35.8864L110.402 36.513C110.331 36.5533 110.241 36.5309 110.197 36.4593L108.91 34.2348C108.892 34.199 108.884 34.1588 108.897 34.1185C108.906 34.0782 108.933 34.0469 108.968 34.029L110.067 33.4024C109.353 32.7444 108.557 32.4938 108.044 32.7892C107.494 33.1025 107.325 33.9797 107.611 35.0226C107.628 35.0897 107.602 35.1613 107.539 35.1926L105.127 36.5712C105.069 36.6025 104.993 36.5935 104.944 36.5443C104.198 35.7879 103.327 35.4791 102.782 35.7924C102.264 36.0878 102.085 36.88 102.3 37.8378L103.399 37.2112C103.47 37.1709 103.564 37.1933 103.604 37.2649L104.89 39.4893C104.908 39.5251 104.917 39.5654 104.904 39.6057C104.895 39.646 104.868 39.6773 104.832 39.6997L103.734 40.3263V40.3218Z",
    fill: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5302 64.9202C73.432 64.9202 73.3516 64.8396 73.3516 64.7411V64.0295C73.3516 63.931 73.432 63.8505 73.5302 63.8505C73.6285 63.8505 73.7089 63.931 73.7089 64.0295V64.7411C73.7089 64.8396 73.6285 64.9202 73.5302 64.9202ZM73.5302 63.4969C73.432 63.4969 73.3516 63.4163 73.3516 63.3178V62.6062C73.3516 62.5077 73.432 62.4272 73.5302 62.4272C73.6285 62.4272 73.7089 62.5077 73.7089 62.6062V63.3178C73.7089 63.4163 73.6285 63.4969 73.5302 63.4969ZM73.5302 62.0736C73.432 62.0736 73.3516 61.993 73.3516 61.8946V61.1829C73.3516 61.0845 73.432 61.0039 73.5302 61.0039C73.6285 61.0039 73.7089 61.0845 73.7089 61.1829V61.8946C73.7089 61.993 73.6285 62.0736 73.5302 62.0736ZM73.5302 60.6503C73.432 60.6503 73.3516 60.5698 73.3516 60.4713V59.7597C73.3516 59.6612 73.432 59.5806 73.5302 59.5806C73.6285 59.5806 73.7089 59.6612 73.7089 59.7597V60.4713C73.7089 60.5698 73.6285 60.6503 73.5302 60.6503ZM73.5302 59.2271C73.432 59.2271 73.3516 59.1465 73.3516 59.048V58.3364C73.3516 58.2379 73.432 58.1574 73.5302 58.1574C73.6285 58.1574 73.7089 58.2379 73.7089 58.3364V59.048C73.7089 59.1465 73.6285 59.2271 73.5302 59.2271ZM73.5302 57.8038C73.432 57.8038 73.3516 57.7232 73.3516 57.6248V56.9131C73.3516 56.8147 73.432 56.7341 73.5302 56.7341C73.6285 56.7341 73.7089 56.8147 73.7089 56.9131V57.6248C73.7089 57.7232 73.6285 57.8038 73.5302 57.8038ZM73.5302 56.3805C73.432 56.3805 73.3516 56.2999 73.3516 56.2015V55.4898C73.3516 55.3914 73.432 55.3108 73.5302 55.3108C73.6285 55.3108 73.7089 55.3914 73.7089 55.4898V56.2015C73.7089 56.2999 73.6285 56.3805 73.5302 56.3805ZM73.5302 54.9572C73.432 54.9572 73.3516 54.8767 73.3516 54.7782V54.0666C73.3516 53.9681 73.432 53.8875 73.5302 53.8875C73.6285 53.8875 73.7089 53.9681 73.7089 54.0666V54.7782C73.7089 54.8767 73.6285 54.9572 73.5302 54.9572ZM73.5302 53.534C73.432 53.534 73.3516 53.4534 73.3516 53.3549V52.6433C73.3516 52.5448 73.432 52.4643 73.5302 52.4643C73.6285 52.4643 73.7089 52.5448 73.7089 52.6433V53.3549C73.7089 53.4534 73.6285 53.534 73.5302 53.534ZM73.5302 52.1107C73.432 52.1107 73.3516 52.0301 73.3516 51.9317V51.22C73.3516 51.1216 73.432 51.041 73.5302 51.041C73.6285 51.041 73.7089 51.1216 73.7089 51.22V51.9317C73.7089 52.0301 73.6285 52.1107 73.5302 52.1107ZM73.5302 50.6874C73.432 50.6874 73.3516 50.6068 73.3516 50.5084V49.7967C73.3516 49.6983 73.432 49.6177 73.5302 49.6177C73.6285 49.6177 73.7089 49.6983 73.7089 49.7967V50.5084C73.7089 50.6068 73.6285 50.6874 73.5302 50.6874ZM73.5302 49.2641C73.432 49.2641 73.3516 49.1836 73.3516 49.0851V48.3735C73.3516 48.275 73.432 48.1944 73.5302 48.1944C73.6285 48.1944 73.7089 48.275 73.7089 48.3735V49.0851C73.7089 49.1836 73.6285 49.2641 73.5302 49.2641ZM73.5302 47.8409C73.432 47.8409 73.3516 47.7603 73.3516 47.6618V46.9502C73.3516 46.8517 73.432 46.7712 73.5302 46.7712C73.6285 46.7712 73.7089 46.8517 73.7089 46.9502V47.6618C73.7089 47.7603 73.6285 47.8409 73.5302 47.8409ZM73.959 46.6593C73.9009 46.6593 73.8384 46.628 73.8072 46.5742C73.758 46.4892 73.7848 46.3818 73.8652 46.3281L74.4727 45.9611C74.5575 45.9118 74.6647 45.9387 74.7183 46.0193C74.7675 46.1043 74.7407 46.2117 74.6603 46.2654L74.0528 46.6324C74.026 46.6503 73.9947 46.6593 73.959 46.6593ZM75.1739 45.9208C75.1158 45.9208 75.0533 45.8895 75.0221 45.8358C74.9729 45.7507 74.9997 45.6433 75.0801 45.5896L75.6876 45.2226C75.7724 45.1733 75.8796 45.2002 75.9332 45.2808C75.9868 45.3613 75.9556 45.4732 75.8752 45.5269L75.2677 45.8939C75.2409 45.9118 75.2096 45.9208 75.1739 45.9208ZM76.3888 45.1823C76.3307 45.1823 76.2682 45.151 76.2369 45.0973C76.1878 45.0122 76.2146 44.9048 76.295 44.8511L76.9025 44.4841C76.9873 44.4349 77.0945 44.4617 77.1481 44.5423C77.1973 44.6273 77.1705 44.7347 77.0901 44.7884L76.4826 45.1554C76.4558 45.1733 76.4201 45.1823 76.3888 45.1823ZM77.6037 44.4438C77.5456 44.4438 77.4831 44.4125 77.4518 44.3588C77.4027 44.2737 77.4295 44.1663 77.5099 44.1126L78.1174 43.7456C78.2022 43.6964 78.3094 43.7232 78.363 43.8038C78.4122 43.8888 78.3854 43.9962 78.305 44.0499L77.6975 44.417C77.6707 44.4349 77.6394 44.4438 77.6037 44.4438ZM78.8186 43.7053C78.7605 43.7053 78.698 43.674 78.6667 43.6203C78.6176 43.5352 78.6444 43.4278 78.7248 43.3741L79.3323 43.0071C79.4171 42.9579 79.5243 42.9847 79.5779 43.0653C79.6271 43.1503 79.6003 43.2577 79.5199 43.3115L78.9124 43.6785C78.8856 43.6964 78.8543 43.7053 78.8186 43.7053ZM80.0335 42.9668C79.9754 42.9668 79.9129 42.9355 79.8816 42.8818C79.8325 42.7967 79.8593 42.6893 79.9397 42.6356L80.5472 42.2686C80.632 42.2194 80.7392 42.2462 80.7928 42.3268C80.842 42.4118 80.8151 42.5193 80.7348 42.573L80.1273 42.94C80.1005 42.9579 80.0692 42.9668 80.0335 42.9668ZM81.2484 42.2283C81.1903 42.2283 81.1278 42.197 81.0965 42.1433C81.0474 42.0583 81.0742 41.9508 81.1546 41.8971L81.7621 41.5301C81.8469 41.4809 81.9541 41.5077 82.0077 41.5883C82.0569 41.6733 82.03 41.7808 81.9497 41.8345L81.3422 42.2015C81.3154 42.2194 81.2797 42.2283 81.2484 42.2283ZM82.4633 41.4898C82.4052 41.4898 82.3427 41.4585 82.3114 41.4048C82.2623 41.3198 82.2891 41.2123 82.3695 41.1586L82.977 40.7916C83.0618 40.7424 83.169 40.7693 83.2226 40.8498C83.2762 40.9304 83.2449 41.0423 83.1646 41.096L82.5571 41.463C82.5303 41.4809 82.499 41.4898 82.4633 41.4898ZM83.6782 40.7514C83.6201 40.7514 83.5576 40.72 83.5263 40.6663C83.4772 40.5813 83.504 40.4739 83.5844 40.4201L84.1919 40.0531C84.2767 40.0039 84.3839 40.0308 84.4375 40.1113C84.4866 40.1964 84.4598 40.3038 84.3794 40.3575L83.772 40.7245C83.7452 40.7424 83.7139 40.7514 83.6782 40.7514ZM84.8931 40.0129C84.835 40.0129 84.7725 39.9815 84.7412 39.9278C84.6921 39.8428 84.7189 39.7354 84.7993 39.6817L85.4068 39.3147C85.4916 39.2654 85.5988 39.2923 85.6524 39.3728C85.7015 39.4579 85.6747 39.5653 85.5943 39.619L84.9869 39.986C84.9601 40.0039 84.9288 40.0129 84.8931 40.0129ZM86.108 39.2744C86.0499 39.2744 85.9874 39.243 85.9561 39.1893C85.907 39.1043 85.9338 38.9969 86.0142 38.9432L86.6216 38.5762C86.7065 38.5269 86.8137 38.5538 86.8673 38.6343C86.9164 38.7194 86.8896 38.8268 86.8092 38.8805L86.2018 39.2475C86.175 39.2654 86.1437 39.2744 86.108 39.2744ZM87.3229 38.5359C87.2648 38.5359 87.2023 38.5046 87.171 38.4508C87.1219 38.3658 87.1487 38.2584 87.2291 38.2047L87.8365 37.8377C87.9214 37.7884 88.0286 37.8153 88.0822 37.8959C88.1313 37.9809 88.1045 38.0883 88.0241 38.142L87.4167 38.509C87.3899 38.5269 87.3542 38.5359 87.3229 38.5359ZM88.5378 37.7974C88.4797 37.7974 88.4172 37.7661 88.3859 37.7124C88.3368 37.6273 88.3636 37.5199 88.444 37.4662L89.0514 37.0992C89.1363 37.0499 89.2435 37.0768 89.2971 37.1574C89.3462 37.2424 89.3194 37.3498 89.239 37.4035L88.6316 37.7705C88.6048 37.7884 88.5735 37.7974 88.5378 37.7974ZM89.7527 37.0589C89.6946 37.0589 89.6321 37.0276 89.6008 36.9739C89.5517 36.8888 89.5785 36.7814 89.6589 36.7277L89.7706 36.6606V36.2801C89.7706 36.1817 89.851 36.1011 89.9492 36.1011C90.0475 36.1011 90.1279 36.1817 90.1279 36.2801V36.759C90.1279 36.8217 90.0966 36.8799 90.043 36.9112L89.8465 37.032C89.8197 37.0499 89.7884 37.0589 89.7527 37.0589ZM89.9492 35.7475C89.851 35.7475 89.7706 35.667 89.7706 35.5685V34.8569C89.7706 34.7584 89.851 34.6778 89.9492 34.6778C90.0475 34.6778 90.1279 34.7584 90.1279 34.8569V35.5685C90.1279 35.667 90.0475 35.7475 89.9492 35.7475ZM89.9492 34.3242C89.851 34.3242 89.7706 34.2437 89.7706 34.1452V33.4336C89.7706 33.3351 89.851 33.2546 89.9492 33.2546C90.0475 33.2546 90.1279 33.3351 90.1279 33.4336V34.1452C90.1279 34.2437 90.0475 34.3242 89.9492 34.3242ZM89.9492 32.901C89.851 32.901 89.7706 32.8204 89.7706 32.7219V32.0103C89.7706 31.9118 89.851 31.8313 89.9492 31.8313C90.0475 31.8313 90.1279 31.9118 90.1279 32.0103V32.7219C90.1279 32.8204 90.0475 32.901 89.9492 32.901ZM89.9492 31.4777C89.851 31.4777 89.7706 31.3971 89.7706 31.2987V30.587C89.7706 30.4886 89.851 30.408 89.9492 30.408C90.0475 30.408 90.1279 30.4886 90.1279 30.587V31.2987C90.1279 31.3971 90.0475 31.4777 89.9492 31.4777ZM89.9492 30.0544C89.851 30.0544 89.7706 29.9739 89.7706 29.8754V29.1638C89.7706 29.0653 89.851 28.9847 89.9492 28.9847C90.0475 28.9847 90.1279 29.0653 90.1279 29.1638V29.8754C90.1279 29.9739 90.0475 30.0544 89.9492 30.0544ZM89.9492 28.6312C89.851 28.6312 89.7706 28.5506 89.7706 28.4521V27.7405C89.7706 27.642 89.851 27.5615 89.9492 27.5615C90.0475 27.5615 90.1279 27.642 90.1279 27.7405V28.4521C90.1279 28.5506 90.0475 28.6312 89.9492 28.6312ZM89.9492 27.2079C89.851 27.2079 89.7706 27.1273 89.7706 27.0288V26.3172C89.7706 26.2187 89.851 26.1382 89.9492 26.1382C90.0475 26.1382 90.1279 26.2187 90.1279 26.3172V27.0288C90.1279 27.1273 90.0475 27.2079 89.9492 27.2079Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M74.624 41.0064C74.5257 41.0064 74.4453 40.9258 74.4453 40.8273V40.6483C74.4453 40.5498 74.5257 40.4693 74.624 40.4693C74.7222 40.4693 74.8026 40.5498 74.8026 40.6483V40.8273C74.8026 40.9258 74.7222 41.0064 74.624 41.0064ZM74.624 40.1157C74.5257 40.1157 74.4453 40.0351 74.4453 39.9367V39.225C74.4453 39.1266 74.5257 39.046 74.624 39.046C74.7222 39.046 74.8026 39.1266 74.8026 39.225V39.9367C74.8026 40.0351 74.7222 40.1157 74.624 40.1157ZM74.624 38.6924C74.5257 38.6924 74.4453 38.6119 74.4453 38.5134V37.8017C74.4453 37.7033 74.5257 37.6227 74.624 37.6227C74.7222 37.6227 74.8026 37.7033 74.8026 37.8017V38.5134C74.8026 38.6119 74.7222 38.6924 74.624 38.6924ZM74.624 37.2691C74.5257 37.2691 74.4453 37.1886 74.4453 37.0901V36.3785C74.4453 36.28 74.5257 36.1994 74.624 36.1994C74.7222 36.1994 74.8026 36.28 74.8026 36.3785V37.0901C74.8026 37.1886 74.7222 37.2691 74.624 37.2691ZM74.624 35.8459C74.5257 35.8459 74.4453 35.7653 74.4453 35.6668V34.9552C74.4453 34.8567 74.5257 34.7762 74.624 34.7762C74.7222 34.7762 74.8026 34.8567 74.8026 34.9552V35.6668C74.8026 35.7653 74.7222 35.8459 74.624 35.8459ZM74.624 34.4226C74.5257 34.4226 74.4453 34.342 74.4453 34.2436V33.5319C74.4453 33.4335 74.5257 33.3529 74.624 33.3529C74.7222 33.3529 74.8026 33.4335 74.8026 33.5319V34.2436C74.8026 34.342 74.7222 34.4226 74.624 34.4226ZM74.624 32.9993C74.5257 32.9993 74.4453 32.9188 74.4453 32.8203V32.1087C74.4453 32.0102 74.5257 31.9296 74.624 31.9296C74.7222 31.9296 74.8026 32.0102 74.8026 32.1087V32.8203C74.8026 32.9188 74.7222 32.9993 74.624 32.9993ZM74.624 31.576C74.5257 31.576 74.4453 31.4955 74.4453 31.397V30.6854C74.4453 30.5869 74.5257 30.5064 74.624 30.5064C74.7222 30.5064 74.8026 30.5869 74.8026 30.6854V31.397C74.8026 31.4955 74.7222 31.576 74.624 31.576ZM74.624 30.1528C74.5257 30.1528 74.4453 30.0722 74.4453 29.9737V29.2621C74.4453 29.1636 74.5257 29.0831 74.624 29.0831C74.7222 29.0831 74.8026 29.1636 74.8026 29.2621V29.9737C74.8026 30.0722 74.7222 30.1528 74.624 30.1528ZM74.624 28.7295C74.5257 28.7295 74.4453 28.6489 74.4453 28.5505V27.8388C74.4453 27.7404 74.5257 27.6598 74.624 27.6598C74.7222 27.6598 74.8026 27.7404 74.8026 27.8388V28.5505C74.8026 28.6489 74.7222 28.7295 74.624 28.7295ZM74.624 27.3062C74.5257 27.3062 74.4453 27.2257 74.4453 27.1272V26.4156C74.4453 26.3171 74.5257 26.2365 74.624 26.2365C74.7222 26.2365 74.8026 26.3171 74.8026 26.4156V27.1272C74.8026 27.2257 74.7222 27.3062 74.624 27.3062ZM74.624 25.883C74.5257 25.883 74.4453 25.8024 74.4453 25.7039V24.9923C74.4453 24.8938 74.5257 24.8133 74.624 24.8133C74.7222 24.8133 74.8026 24.8938 74.8026 24.9923V25.7039C74.8026 25.8024 74.7222 25.883 74.624 25.883ZM74.624 24.4597C74.5257 24.4597 74.4453 24.3791 74.4453 24.2806V23.569C74.4453 23.4705 74.5257 23.39 74.624 23.39C74.7222 23.39 74.8026 23.4705 74.8026 23.569V24.2806C74.8026 24.3791 74.7222 24.4597 74.624 24.4597ZM74.624 23.0364C74.5257 23.0364 74.4453 22.9558 74.4453 22.8574V22.1457C74.4453 22.0473 74.5257 21.9667 74.624 21.9667C74.7222 21.9667 74.8026 22.0473 74.8026 22.1457V22.8574C74.8026 22.9558 74.7222 23.0364 74.624 23.0364ZM74.624 21.6131C74.5257 21.6131 74.4453 21.5326 74.4453 21.4341V20.7225C74.4453 20.624 74.5257 20.5434 74.624 20.5434C74.7222 20.5434 74.8026 20.624 74.8026 20.7225V21.4341C74.8026 21.5326 74.7222 21.6131 74.624 21.6131ZM74.624 20.1899C74.5257 20.1899 74.4453 20.1093 74.4453 20.0108V19.2992C74.4453 19.2007 74.5257 19.1202 74.624 19.1202C74.7222 19.1202 74.8026 19.2007 74.8026 19.2992V20.0108C74.8026 20.1093 74.7222 20.1899 74.624 20.1899ZM74.624 18.7666C74.5257 18.7666 74.4453 18.686 74.4453 18.5876V17.8759C74.4453 17.7775 74.5257 17.6969 74.624 17.6969C74.7222 17.6969 74.8026 17.7775 74.8026 17.8759V18.5876C74.8026 18.686 74.7222 18.7666 74.624 18.7666ZM74.624 17.3433C74.5257 17.3433 74.4453 17.2627 74.4453 17.1643V16.4526C74.4453 16.3542 74.5257 16.2736 74.624 16.2736C74.7222 16.2736 74.8026 16.3542 74.8026 16.4526V17.1643C74.8026 17.2627 74.7222 17.3433 74.624 17.3433ZM74.624 15.92C74.5257 15.92 74.4453 15.8395 74.4453 15.741V15.0294C74.4453 14.9309 74.5257 14.8503 74.624 14.8503C74.7222 14.8503 74.8026 14.9309 74.8026 15.0294V15.741C74.8026 15.8395 74.7222 15.92 74.624 15.92Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M41.499 45.1555C41.4007 45.1555 41.3203 45.0749 41.3203 44.9764V44.2648C41.3203 44.1663 41.4007 44.0858 41.499 44.0858C41.5972 44.0858 41.6776 44.1663 41.6776 44.2648V44.9764C41.6776 45.0749 41.5972 45.1555 41.499 45.1555ZM41.499 43.7322C41.4007 43.7322 41.3203 43.6516 41.3203 43.5532V42.8415C41.3203 42.7431 41.4007 42.6625 41.499 42.6625C41.5972 42.6625 41.6776 42.7431 41.6776 42.8415V43.5532C41.6776 43.6516 41.5972 43.7322 41.499 43.7322ZM41.499 42.3089C41.4007 42.3089 41.3203 42.2283 41.3203 42.1299V41.4182C41.3203 41.3198 41.4007 41.2392 41.499 41.2392C41.5972 41.2392 41.6776 41.3198 41.6776 41.4182V42.1299C41.6776 42.2283 41.5972 42.3089 41.499 42.3089ZM41.499 40.8856C41.4007 40.8856 41.3203 40.8051 41.3203 40.7066V39.995C41.3203 39.8965 41.4007 39.8159 41.499 39.8159C41.5972 39.8159 41.6776 39.8965 41.6776 39.995V40.7066C41.6776 40.8051 41.5972 40.8856 41.499 40.8856ZM41.499 39.4624C41.4007 39.4624 41.3203 39.3818 41.3203 39.2833V38.5717C41.3203 38.4732 41.4007 38.3927 41.499 38.3927C41.5972 38.3927 41.6776 38.4732 41.6776 38.5717V39.2833C41.6776 39.3818 41.5972 39.4624 41.499 39.4624ZM41.499 38.0391C41.4007 38.0391 41.3203 37.9585 41.3203 37.8601V37.1484C41.3203 37.05 41.4007 36.9694 41.499 36.9694C41.5972 36.9694 41.6776 37.05 41.6776 37.1484V37.8601C41.6776 37.9585 41.5972 38.0391 41.499 38.0391ZM41.499 36.6158C41.4007 36.6158 41.3203 36.5353 41.3203 36.4368V35.7252C41.3203 35.6267 41.4007 35.5461 41.499 35.5461C41.5972 35.5461 41.6776 35.6267 41.6776 35.7252V36.4368C41.6776 36.5353 41.5972 36.6158 41.499 36.6158ZM41.499 35.1925C41.4007 35.1925 41.3203 35.112 41.3203 35.0135V34.3019C41.3203 34.2034 41.4007 34.1229 41.499 34.1229C41.5972 34.1229 41.6776 34.2034 41.6776 34.3019V35.0135C41.6776 35.112 41.5972 35.1925 41.499 35.1925ZM41.499 33.7693C41.4007 33.7693 41.3203 33.6887 41.3203 33.5902V32.8786C41.3203 32.7801 41.4007 32.6996 41.499 32.6996C41.5972 32.6996 41.6776 32.7801 41.6776 32.8786V33.5902C41.6776 33.6887 41.5972 33.7693 41.499 33.7693ZM41.499 32.346C41.4007 32.346 41.3203 32.2654 41.3203 32.167V31.4553C41.3203 31.3569 41.4007 31.2763 41.499 31.2763C41.5972 31.2763 41.6776 31.3569 41.6776 31.4553V32.167C41.6776 32.2654 41.5972 32.346 41.499 32.346ZM41.499 30.9227C41.4007 30.9227 41.3203 30.8422 41.3203 30.7437V30.0321C41.3203 29.9336 41.4007 29.853 41.499 29.853C41.5972 29.853 41.6776 29.9336 41.6776 30.0321V30.7437C41.6776 30.8422 41.5972 30.9227 41.499 30.9227ZM41.499 29.4995C41.4007 29.4995 41.3203 29.4189 41.3203 29.3204V28.6088C41.3203 28.5103 41.4007 28.4298 41.499 28.4298C41.5972 28.4298 41.6776 28.5103 41.6776 28.6088V29.3204C41.6776 29.4189 41.5972 29.4995 41.499 29.4995ZM41.499 28.0762C41.4007 28.0762 41.3203 27.9956 41.3203 27.8972V27.1855C41.3203 27.087 41.4007 27.0065 41.499 27.0065C41.5972 27.0065 41.6776 27.087 41.6776 27.1855V27.8972C41.6776 27.9956 41.5972 28.0762 41.499 28.0762ZM41.499 26.6529C41.4007 26.6529 41.3203 26.5723 41.3203 26.4739V25.7622C41.3203 25.6638 41.4007 25.5832 41.499 25.5832C41.5972 25.5832 41.6776 25.6638 41.6776 25.7622V26.4739C41.6776 26.5723 41.5972 26.6529 41.499 26.6529ZM41.499 25.2296C41.4007 25.2296 41.3203 25.1491 41.3203 25.0506V24.339C41.3203 24.2405 41.4007 24.1599 41.499 24.1599C41.5972 24.1599 41.6776 24.2405 41.6776 24.339V25.0506C41.6776 25.1491 41.5972 25.2296 41.499 25.2296ZM41.499 23.8064C41.4007 23.8064 41.3203 23.7258 41.3203 23.6273V22.9157C41.3203 22.8172 41.4007 22.7367 41.499 22.7367C41.5972 22.7367 41.6776 22.8172 41.6776 22.9157V23.6273C41.6776 23.7258 41.5972 23.8064 41.499 23.8064ZM41.499 22.3831C41.4007 22.3831 41.3203 22.3025 41.3203 22.2041V21.4924C41.3203 21.394 41.4007 21.3134 41.499 21.3134C41.5972 21.3134 41.6776 21.394 41.6776 21.4924V22.2041C41.6776 22.3025 41.5972 22.3831 41.499 22.3831ZM41.499 20.9598C41.4007 20.9598 41.3203 20.8792 41.3203 20.7808V20.0691C41.3203 19.9707 41.4007 19.8901 41.499 19.8901C41.5972 19.8901 41.6776 19.9707 41.6776 20.0691V20.7808C41.6776 20.8792 41.5972 20.9598 41.499 20.9598ZM41.499 19.5365C41.4007 19.5365 41.3203 19.456 41.3203 19.3575V18.6459C41.3203 18.5474 41.4007 18.4668 41.499 18.4668C41.5972 18.4668 41.6776 18.5474 41.6776 18.6459V19.3575C41.6776 19.456 41.5972 19.5365 41.499 19.5365ZM41.499 18.1133C41.4007 18.1133 41.3203 18.0327 41.3203 17.9342V17.2226C41.3203 17.1241 41.4007 17.0436 41.499 17.0436C41.5972 17.0436 41.6776 17.1241 41.6776 17.2226V17.9342C41.6776 18.0327 41.5972 18.1133 41.499 18.1133ZM41.499 16.69C41.4007 16.69 41.3203 16.6094 41.3203 16.511V15.7993C41.3203 15.7009 41.4007 15.6203 41.499 15.6203C41.5972 15.6203 41.6776 15.7009 41.6776 15.7993V16.511C41.6776 16.6094 41.5972 16.69 41.499 16.69ZM41.499 15.2667C41.4007 15.2667 41.3203 15.1862 41.3203 15.0877V14.376C41.3203 14.2776 41.4007 14.197 41.499 14.197C41.5972 14.197 41.6776 14.2776 41.6776 14.376V15.0877C41.6776 15.1862 41.5972 15.2667 41.499 15.2667Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3765 67.7937C39.2782 67.7937 39.1978 67.7131 39.1978 67.6147V66.903C39.1978 66.8045 39.2782 66.724 39.3765 66.724C39.4747 66.724 39.5551 66.8045 39.5551 66.903V67.6147C39.5551 67.7131 39.4747 67.7937 39.3765 67.7937ZM39.3765 66.3704C39.2782 66.3704 39.1978 66.2898 39.1978 66.1914V65.4797C39.1978 65.3813 39.2782 65.3007 39.3765 65.3007C39.4747 65.3007 39.5551 65.3813 39.5551 65.4797V66.1914C39.5551 66.2898 39.4747 66.3704 39.3765 66.3704ZM39.3765 64.9471C39.2782 64.9471 39.1978 64.8666 39.1978 64.7681V64.0565C39.1978 63.958 39.2782 63.8774 39.3765 63.8774C39.4747 63.8774 39.5551 63.958 39.5551 64.0565V64.7681C39.5551 64.8666 39.4747 64.9471 39.3765 64.9471ZM39.3765 63.5239C39.2782 63.5239 39.1978 63.4433 39.1978 63.3448V62.6332C39.1978 62.5347 39.2782 62.4542 39.3765 62.4542C39.4747 62.4542 39.5551 62.5347 39.5551 62.6332V63.3448C39.5551 63.4433 39.4747 63.5239 39.3765 63.5239ZM39.3765 62.1006C39.2782 62.1006 39.1978 62.02 39.1978 61.9216V61.2099C39.1978 61.1115 39.2782 61.0309 39.3765 61.0309C39.4747 61.0309 39.5551 61.1115 39.5551 61.2099V61.9216C39.5551 62.02 39.4747 62.1006 39.3765 62.1006ZM39.3765 60.6773C39.2782 60.6773 39.1978 60.5967 39.1978 60.4983V59.7866C39.1978 59.6882 39.2782 59.6076 39.3765 59.6076C39.4747 59.6076 39.5551 59.6882 39.5551 59.7866V60.4983C39.5551 60.5967 39.4747 60.6773 39.3765 60.6773ZM39.3765 59.254C39.2782 59.254 39.1978 59.1735 39.1978 59.075V58.3634C39.1978 58.2649 39.2782 58.1843 39.3765 58.1843C39.4747 58.1843 39.5551 58.2649 39.5551 58.3634V59.075C39.5551 59.1735 39.4747 59.254 39.3765 59.254ZM39.3765 57.8308C39.2782 57.8308 39.1978 57.7502 39.1978 57.6517V56.9401C39.1978 56.8416 39.2782 56.7611 39.3765 56.7611C39.4747 56.7611 39.5551 56.8416 39.5551 56.9401V57.6517C39.5551 57.7502 39.4747 57.8308 39.3765 57.8308ZM39.3765 56.4075C39.2782 56.4075 39.1978 56.3269 39.1978 56.2285V55.5168C39.1978 55.4184 39.2782 55.3378 39.3765 55.3378C39.4747 55.3378 39.5551 55.4184 39.5551 55.5168V56.2285C39.5551 56.3269 39.4747 56.4075 39.3765 56.4075ZM39.3765 54.9842C39.2782 54.9842 39.1978 54.9037 39.1978 54.8052V54.0936C39.1978 53.9951 39.2782 53.9145 39.3765 53.9145C39.4747 53.9145 39.5551 53.9951 39.5551 54.0936V54.8052C39.5551 54.9037 39.4747 54.9842 39.3765 54.9842ZM39.3765 53.5609C39.2782 53.5609 39.1978 53.4804 39.1978 53.3819V52.6703C39.1978 52.5718 39.2782 52.4912 39.3765 52.4912C39.4747 52.4912 39.5551 52.5718 39.5551 52.6703V53.3819C39.5551 53.4804 39.4747 53.5609 39.3765 53.5609ZM39.3765 52.1377C39.2782 52.1377 39.1978 52.0571 39.1978 51.9586V51.247C39.1978 51.1485 39.2782 51.068 39.3765 51.068C39.4747 51.068 39.5551 51.1485 39.5551 51.247V51.9586C39.5551 52.0571 39.4747 52.1377 39.3765 52.1377ZM38.8851 51.0008C38.8539 51.0008 38.8271 50.9919 38.8003 50.9785L38.1839 50.6294C38.099 50.5801 38.0678 50.4727 38.1169 50.3877C38.166 50.3026 38.2732 50.2713 38.3581 50.3205L38.9745 50.6696C39.0593 50.7189 39.0906 50.8263 39.0415 50.9113C39.0102 50.9695 38.9477 51.0008 38.8851 51.0008ZM37.6479 50.3026C37.6166 50.3026 37.5898 50.2937 37.563 50.2803L36.9467 49.9311C36.8618 49.8819 36.8305 49.7745 36.8797 49.6895C36.9288 49.6044 37.036 49.5731 37.1209 49.6223L37.7372 49.9714C37.8221 50.0207 37.8534 50.1281 37.8042 50.2131C37.773 50.2713 37.7104 50.3026 37.6479 50.3026ZM36.4107 49.6044C36.3794 49.6044 36.3526 49.5955 36.3258 49.582L35.7094 49.2329C35.6246 49.1837 35.5933 49.0763 35.6424 48.9912C35.6916 48.9062 35.7988 48.8749 35.8836 48.9241L36.5 49.2732C36.5849 49.3224 36.6161 49.4299 36.567 49.5149C36.5357 49.5731 36.4732 49.6044 36.4107 49.6044ZM35.1735 48.9062C35.1422 48.9062 35.1154 48.8973 35.0886 48.8838L34.4722 48.5347C34.3873 48.4855 34.3561 48.3781 34.4052 48.293C34.4543 48.208 34.5615 48.1767 34.6464 48.2259L35.2628 48.575C35.3476 48.6242 35.3789 48.7317 35.3298 48.8167C35.2985 48.8749 35.236 48.9062 35.1735 48.9062ZM33.9362 48.208C33.905 48.208 33.8782 48.1991 33.8514 48.1856L33.235 47.8365C33.1501 47.7873 33.1188 47.6799 33.168 47.5948C33.2171 47.5098 33.3243 47.4785 33.4092 47.5277L34.0256 47.8768C34.1104 47.926 34.1417 48.0334 34.0926 48.1185C34.0613 48.1767 33.9988 48.208 33.9362 48.208ZM32.699 47.5098C32.6677 47.5098 32.6409 47.5008 32.6141 47.4874L31.9977 47.1383C31.9129 47.0891 31.8816 46.9817 31.9307 46.8966C31.9799 46.8116 32.0871 46.7803 32.1719 46.8295L32.7883 47.1786C32.8732 47.2278 32.9044 47.3352 32.8553 47.4203C32.8241 47.4785 32.7615 47.5098 32.699 47.5098ZM31.4618 46.8116C31.4305 46.8116 31.4037 46.8026 31.3769 46.7892L30.7605 46.4401C30.6756 46.3909 30.6444 46.2834 30.6935 46.1984C30.7426 46.1134 30.8498 46.082 30.9347 46.1313L31.5511 46.4804C31.636 46.5296 31.6672 46.637 31.6181 46.7221C31.5868 46.7803 31.5243 46.8116 31.4618 46.8116ZM30.2245 46.1134C30.1933 46.1134 30.1665 46.1044 30.1397 46.091L29.5233 45.7419C29.4384 45.6927 29.4071 45.5852 29.4563 45.5002C29.5054 45.4152 29.6126 45.3838 29.6975 45.4331L30.3139 45.7822C30.3987 45.8314 30.43 45.9388 30.3809 46.0239C30.3496 46.082 30.2871 46.1134 30.2245 46.1134ZM28.9873 45.4152C28.956 45.4152 28.9292 45.4062 28.9024 45.3928L28.286 45.0437C28.2012 44.9944 28.1699 44.887 28.219 44.802C28.2682 44.717 28.3754 44.6856 28.4602 44.7349L29.0766 45.084C29.1615 45.1332 29.1928 45.2406 29.1436 45.3256C29.1124 45.3838 29.0498 45.4152 28.9873 45.4152ZM27.7501 44.717C27.7188 44.717 27.692 44.708 27.6652 44.6946L27.0488 44.3455C26.964 44.2962 26.9327 44.1888 26.9818 44.1038C27.0309 44.0187 27.1381 43.9874 27.223 44.0366L27.8394 44.3857C27.9243 44.435 27.9555 44.5424 27.9064 44.6274C27.8751 44.6856 27.8126 44.717 27.7501 44.717ZM26.5128 44.0187C26.4816 44.0187 26.4548 44.0098 26.428 43.9964L25.8116 43.6473C25.7267 43.598 25.6955 43.4906 25.7446 43.4056C25.7937 43.3205 25.9009 43.2892 25.9858 43.3384L26.6022 43.6875C26.687 43.7368 26.7183 43.8442 26.6692 43.9292C26.6379 43.9874 26.5754 44.0187 26.5128 44.0187ZM25.2756 43.3205C25.2443 43.3205 25.2175 43.3116 25.1907 43.2982L24.5744 42.949C24.4895 42.8998 24.4582 42.7924 24.5074 42.7074C24.5565 42.6223 24.6637 42.591 24.7485 42.6402L25.3649 42.9893C25.4498 43.0386 25.4811 43.146 25.4319 43.231C25.4007 43.2892 25.3381 43.3205 25.2756 43.3205ZM24.0384 42.6223C24.0071 42.6223 23.9803 42.6134 23.9535 42.5999L23.3371 42.2508C23.2523 42.2016 23.221 42.0942 23.2701 42.0092C23.3193 41.9241 23.4265 41.8928 23.5113 41.942L24.1277 42.2911C24.2126 42.3404 24.2438 42.4478 24.1947 42.5328C24.1634 42.591 24.1009 42.6223 24.0384 42.6223ZM22.8011 41.9241C22.7699 41.9241 22.7431 41.9152 22.7163 41.9017L22.0999 41.5526C22.015 41.5034 21.9838 41.396 22.0329 41.3109C22.082 41.2259 22.1892 41.1946 22.2741 41.2438L22.8905 41.5929C22.9753 41.6421 23.0066 41.7496 22.9575 41.8346C22.9262 41.8928 22.8637 41.9241 22.8011 41.9241ZM21.5639 41.2259C21.5326 41.2259 21.5058 41.217 21.479 41.2035L20.8627 40.8544C20.7778 40.8052 20.7465 40.6978 20.7957 40.6127C20.8448 40.5277 20.952 40.4964 21.0369 40.5456L21.6532 40.8947C21.7381 40.9439 21.7694 41.0514 21.7202 41.1364C21.689 41.1946 21.6264 41.2259 21.5639 41.2259ZM20.3267 40.5277C20.2954 40.5277 20.2686 40.5187 20.2418 40.5053L19.6254 40.1562C19.5406 40.107 19.5093 39.9996 19.5584 39.9145C19.6076 39.8295 19.7148 39.7982 19.7996 39.8474L20.416 40.1965C20.5009 40.2457 20.5321 40.3531 20.483 40.4382C20.4517 40.4964 20.3892 40.5277 20.3267 40.5277ZM19.0894 39.8295C19.0582 39.8295 19.0314 39.8205 19.0001 39.8071L18.8706 39.731C18.817 39.6997 18.7812 39.6415 18.7812 39.5744V39.0149C18.7812 38.9164 18.8616 38.8359 18.9599 38.8359C19.0582 38.8359 19.1386 38.9164 19.1386 39.0149V39.4714L19.1788 39.4938C19.2636 39.543 19.2949 39.6505 19.2458 39.7355C19.2145 39.7937 19.152 39.825 19.0894 39.825V39.8295ZM18.9599 38.4823C18.8616 38.4823 18.7812 38.4017 18.7812 38.3033V37.5916C18.7812 37.4932 18.8616 37.4126 18.9599 37.4126C19.0582 37.4126 19.1386 37.4932 19.1386 37.5916V38.3033C19.1386 38.4017 19.0582 38.4823 18.9599 38.4823ZM18.9599 37.059C18.8616 37.059 18.7812 36.9785 18.7812 36.88V36.1684C18.7812 36.0699 18.8616 35.9893 18.9599 35.9893C19.0582 35.9893 19.1386 36.0699 19.1386 36.1684V36.88C19.1386 36.9785 19.0582 37.059 18.9599 37.059ZM18.9599 35.6358C18.8616 35.6358 18.7812 35.5552 18.7812 35.4567V34.7451C18.7812 34.6466 18.8616 34.5661 18.9599 34.5661C19.0582 34.5661 19.1386 34.6466 19.1386 34.7451V35.4567C19.1386 35.5552 19.0582 35.6358 18.9599 35.6358ZM18.9599 34.2125C18.8616 34.2125 18.7812 34.1319 18.7812 34.0334V33.3218C18.7812 33.2233 18.8616 33.1428 18.9599 33.1428C19.0582 33.1428 19.1386 33.2233 19.1386 33.3218V34.0334C19.1386 34.1319 19.0582 34.2125 18.9599 34.2125ZM18.9599 32.7892C18.8616 32.7892 18.7812 32.7086 18.7812 32.6102V31.8985C18.7812 31.8001 18.8616 31.7195 18.9599 31.7195C19.0582 31.7195 19.1386 31.8001 19.1386 31.8985V32.6102C19.1386 32.7086 19.0582 32.7892 18.9599 32.7892ZM18.9599 31.3659C18.8616 31.3659 18.7812 31.2854 18.7812 31.1869V30.7393C18.7812 30.6409 18.8616 30.5603 18.9599 30.5603C19.0582 30.5603 19.1386 30.6409 19.1386 30.7393V31.1869C19.1386 31.2854 19.0582 31.3659 18.9599 31.3659Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M105.248 45.9745C105.216 45.9745 105.185 45.9655 105.158 45.9521L104.546 45.594C104.462 45.5448 104.435 45.4374 104.484 45.3523C104.533 45.2673 104.645 45.2404 104.725 45.2897L105.337 45.6477C105.422 45.697 105.449 45.8044 105.4 45.8894C105.368 45.9476 105.306 45.9789 105.248 45.9789V45.9745ZM105.471 45.6522C105.373 45.6522 105.292 45.5716 105.292 45.4732V44.7615C105.292 44.6631 105.373 44.5825 105.471 44.5825C105.569 44.5825 105.65 44.6631 105.65 44.7615V45.4732C105.65 45.5716 105.569 45.6522 105.471 45.6522ZM104.024 45.2584C103.993 45.2584 103.961 45.2494 103.935 45.236L103.323 44.8779C103.238 44.8287 103.211 44.7213 103.26 44.6362C103.309 44.5512 103.421 44.5243 103.501 44.5736L104.113 44.9316C104.198 44.9809 104.225 45.0883 104.176 45.1733C104.144 45.2315 104.082 45.2628 104.024 45.2628V45.2584ZM102.8 44.5378C102.769 44.5378 102.737 44.5288 102.711 44.5154L102.099 44.1573C102.014 44.1081 101.987 44.0007 102.036 43.9156C102.085 43.8306 102.197 43.8037 102.277 43.853L102.889 44.211C102.974 44.2603 103.001 44.3677 102.952 44.4527C102.921 44.5109 102.858 44.5422 102.8 44.5422V44.5378ZM105.471 44.2289C105.373 44.2289 105.292 44.1484 105.292 44.0499V43.3383C105.292 43.2398 105.373 43.1592 105.471 43.1592C105.569 43.1592 105.65 43.2398 105.65 43.3383V44.0499C105.65 44.1484 105.569 44.2289 105.471 44.2289ZM101.576 43.8172C101.545 43.8172 101.514 43.8082 101.487 43.7948L100.875 43.4367C100.79 43.3875 100.763 43.2801 100.812 43.1951C100.862 43.11 100.973 43.0832 101.054 43.1324L101.666 43.4904C101.75 43.5397 101.777 43.6471 101.728 43.7321C101.697 43.7903 101.634 43.8217 101.576 43.8217V43.8172ZM100.352 43.0966C100.321 43.0966 100.29 43.0876 100.263 43.0742L99.6511 42.7162C99.5663 42.6669 99.5395 42.5595 99.5886 42.4745C99.6377 42.3894 99.7494 42.3626 99.8298 42.4118L100.442 42.7699C100.527 42.8191 100.553 42.9265 100.504 43.0115C100.473 43.0697 100.41 43.1011 100.352 43.1011V43.0966ZM105.471 42.8057C105.373 42.8057 105.292 42.7251 105.292 42.6266V42.1925C105.292 42.094 105.373 42.0135 105.471 42.0135C105.569 42.0135 105.65 42.094 105.65 42.1925V42.6266C105.65 42.7251 105.569 42.8057 105.471 42.8057ZM99.1285 42.376C99.0973 42.376 99.066 42.367 99.0392 42.3536L98.4273 41.9956C98.3424 41.9463 98.3156 41.8389 98.3648 41.7539C98.4139 41.6688 98.5255 41.642 98.6059 41.6912L99.2179 42.0493C99.3027 42.0985 99.3295 42.2059 99.2804 42.291C99.2491 42.3491 99.1866 42.3805 99.1285 42.3805V42.376ZM97.9047 41.6554C97.8734 41.6554 97.8422 41.6465 97.8154 41.633L97.2034 41.275C97.1186 41.2257 97.0918 41.1183 97.1409 41.0333C97.19 40.9482 97.2972 40.9214 97.3821 40.9706L97.994 41.3287C98.0789 41.3779 98.1057 41.4853 98.0566 41.5704C98.0253 41.6286 97.9628 41.6599 97.9047 41.6599V41.6554ZM96.6809 40.9348C96.6496 40.9348 96.6183 40.9259 96.5915 40.9124L95.9796 40.5544C95.8948 40.5052 95.868 40.3977 95.9171 40.3127C95.9662 40.2277 96.0779 40.2008 96.1583 40.25L96.7702 40.6081C96.8551 40.6573 96.8819 40.7647 96.8327 40.8498C96.8015 40.908 96.7389 40.9393 96.6809 40.9393V40.9348ZM95.457 40.2142C95.4258 40.2142 95.3945 40.2053 95.3677 40.1919L94.7558 39.8338C94.6709 39.7846 94.6441 39.6771 94.6933 39.5921C94.7424 39.5071 94.854 39.4802 94.9344 39.5294L95.5464 39.8875C95.6312 39.9367 95.658 40.0442 95.6089 40.1292C95.5776 40.1874 95.5151 40.2187 95.457 40.2187V40.2142ZM94.2332 39.4936C94.2019 39.4936 94.1707 39.4847 94.1439 39.4713L93.532 39.1132C93.4471 39.064 93.4203 38.9566 93.4694 38.8715C93.5186 38.7865 93.6302 38.7596 93.7106 38.8089L94.3225 39.1669C94.4074 39.2162 94.4342 39.3236 94.3851 39.4086C94.3538 39.4668 94.2913 39.4981 94.2332 39.4981V39.4936ZM93.0094 38.7731C92.9781 38.7731 92.9468 38.7641 92.92 38.7507L92.3081 38.3926C92.2233 38.3434 92.1965 38.236 92.2456 38.1509C92.2947 38.0659 92.4064 38.039 92.4868 38.0883L93.0987 38.4463C93.1836 38.4956 93.2104 38.603 93.1612 38.688C93.13 38.7462 93.0674 38.7775 93.0094 38.7775V38.7731ZM91.7855 38.0525C91.7543 38.0525 91.723 38.0435 91.6962 38.0301L91.0843 37.672C90.9994 37.6228 90.9726 37.5154 91.0218 37.4303C91.0709 37.3453 91.1826 37.3185 91.263 37.3677L91.8749 37.7257C91.9597 37.775 91.9865 37.8824 91.9374 37.9674C91.9061 38.0256 91.8436 38.0569 91.7855 38.0569V38.0525ZM90.5617 37.3319C90.5304 37.3319 90.4992 37.3229 90.4724 37.3095L89.8605 36.9514C89.7756 36.9022 89.7488 36.7948 89.7979 36.7098C89.8471 36.6247 89.9587 36.5979 90.0391 36.6471L90.651 37.0052C90.7359 37.0544 90.7627 37.1618 90.7136 37.2468C90.6823 37.305 90.6198 37.3364 90.5617 37.3364V37.3319Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8862 20.2346C73.8862 20.2346 73.846 20.2346 73.8282 20.2257L73.6004 20.1496C73.5066 20.1183 73.4575 20.0153 73.4887 19.9258C73.52 19.8318 73.6227 19.7826 73.7121 19.8139L73.9398 19.89C74.0336 19.9213 74.0828 20.0243 74.0515 20.1138C74.0247 20.1899 73.9577 20.2346 73.8818 20.2346H73.8862ZM72.984 19.9303C72.984 19.9303 72.9438 19.9303 72.9259 19.9213L72.2515 19.6931C72.1577 19.6617 72.1086 19.5588 72.1398 19.4693C72.1711 19.3753 72.2738 19.3305 72.3632 19.3574L73.0376 19.5857C73.1314 19.617 73.1805 19.7199 73.1493 19.8094C73.1225 19.8855 73.0555 19.9303 72.9795 19.9303H72.984ZM71.6396 19.4738C71.6396 19.4738 71.5994 19.4738 71.5815 19.4648L70.9071 19.2366C70.8133 19.2052 70.7641 19.1023 70.7954 19.0128C70.8267 18.9188 70.9294 18.8695 71.0187 18.9009L71.6932 19.1291C71.787 19.1605 71.8361 19.2634 71.8048 19.3529C71.778 19.429 71.711 19.4738 71.6351 19.4738H71.6396ZM70.2952 19.0172C70.2952 19.0172 70.255 19.0172 70.2371 19.0083L69.5626 18.78C69.4688 18.7487 69.4197 18.6458 69.451 18.5562C69.4822 18.4623 69.585 18.413 69.6743 18.4444L70.3487 18.6726C70.4425 18.7039 70.4917 18.8069 70.4604 18.8964C70.4336 18.9725 70.3666 19.0172 70.2907 19.0172H70.2952ZM68.9507 18.5607C68.9507 18.5607 68.9105 18.5607 68.8927 18.5518L68.2182 18.3235C68.1244 18.2922 68.0753 18.1892 68.1065 18.0997C68.1378 18.0057 68.2405 17.9565 68.3299 17.9878L69.0043 18.2161C69.0981 18.2474 69.1473 18.3504 69.116 18.4399C69.0892 18.516 69.0222 18.5607 68.9463 18.5607H68.9507ZM67.6063 18.1042C67.6063 18.1042 67.5661 18.1042 67.5482 18.0952L66.8738 17.867C66.78 17.8357 66.7309 17.7327 66.7621 17.6432C66.7934 17.5492 66.8961 17.5 66.9854 17.5313L67.6599 17.7596C67.7537 17.7909 67.8028 17.8938 67.7716 17.9834C67.7448 18.0594 67.6778 18.1042 67.6018 18.1042H67.6063ZM66.2619 17.6477C66.2619 17.6477 66.2217 17.6477 66.2038 17.6387L65.5294 17.4105C65.4356 17.3791 65.3864 17.2762 65.4177 17.1867C65.449 17.0927 65.5517 17.0435 65.641 17.0748L66.3155 17.303C66.4093 17.3344 66.4584 17.4373 66.4271 17.5268C66.4003 17.6029 66.3333 17.6477 66.2574 17.6477H66.2619ZM64.9174 17.1912C64.9174 17.1912 64.8772 17.1912 64.8594 17.1822L64.1849 16.9539C64.0911 16.9226 64.042 16.8197 64.0733 16.7302C64.1045 16.6362 64.2073 16.5869 64.2966 16.6183L64.971 16.8465C65.0648 16.8779 65.114 16.9808 65.0827 17.0703C65.0559 17.1464 64.9889 17.1912 64.913 17.1912H64.9174ZM63.573 16.7346C63.573 16.7346 63.5328 16.7346 63.5149 16.7257L62.8405 16.4974C62.7467 16.4661 62.6976 16.3631 62.7288 16.2736C62.7601 16.1796 62.8628 16.1304 62.9522 16.1617L63.6266 16.39C63.7204 16.4213 63.7695 16.5243 63.7383 16.6138C63.7115 16.6899 63.6445 16.7346 63.5685 16.7346H63.573ZM62.2286 16.2781C62.2286 16.2781 62.1884 16.2781 62.1705 16.2692L61.4961 16.0409C61.4023 16.0096 61.3531 15.9066 61.3844 15.8171C61.4157 15.7231 61.5184 15.6739 61.6077 15.7052L62.2822 15.9335C62.376 15.9648 62.4251 16.0678 62.3938 16.1573C62.367 16.2334 62.3 16.2781 62.2241 16.2781H62.2286Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2785 13.5345C41.2785 13.5345 41.2339 13.5345 41.2115 13.5211C38.5897 12.4917 36.7763 10.961 36.4413 6.83438L36.3519 5.7244C36.3475 5.65727 36.3832 5.59013 36.4413 5.55432L36.5038 5.51852C38.1743 4.56967 39.7822 3.06136 41.1579 1.16366C41.1713 1.14128 41.1937 1.12785 41.2115 1.11443C41.2517 1.09205 41.3143 1.07415 41.3589 1.0831C42.6855 1.38297 44.3113 1.01596 45.9371 0.0581608L45.9997 0.0178795C46.0577 -0.0179261 46.1292 -0.0134504 46.1828 0.0178795C46.2409 0.0536851 46.2721 0.116345 46.2677 0.183481L46.1783 1.3964C45.8433 5.84524 44.0657 9.41686 41.4929 13.4047C41.4795 13.4271 41.4572 13.4495 41.4304 13.4629L41.3634 13.4987C41.3366 13.5121 41.3053 13.5211 41.2741 13.5211L41.2785 13.5345ZM36.7137 5.81392L36.7941 6.812C37.1113 10.6969 38.7996 12.1739 41.2383 13.1541C43.7575 9.23783 45.4994 5.73335 45.8255 1.38297L45.8925 0.501255C44.3024 1.38744 42.7168 1.72312 41.3857 1.45906C40.0056 3.3478 38.3931 4.85164 36.7137 5.81392Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2963 10.4776C41.2963 10.4776 41.2517 10.4776 41.2293 10.4642C39.608 9.82414 38.8799 8.81263 38.7325 6.96864L38.6879 6.40023C38.6834 6.33309 38.7191 6.26596 38.7772 6.23015L38.8085 6.21225C39.6526 5.73335 40.47 4.968 41.1623 4.00573C41.1757 3.98335 41.1981 3.96992 41.2159 3.9565C41.2561 3.93412 41.3097 3.92069 41.3544 3.92964C42.011 4.07734 42.8239 3.89384 43.6368 3.41494L43.6681 3.39703C43.7261 3.3657 43.7976 3.3657 43.8512 3.39703C43.9093 3.43284 43.9405 3.4955 43.9361 3.56263L43.8914 4.18476C43.7217 6.48079 42.8016 8.32031 41.475 10.3747C41.4616 10.397 41.4393 10.4194 41.4169 10.4328L41.3857 10.4507C41.3589 10.4686 41.3276 10.4731 41.2963 10.4731V10.4776ZM39.0497 6.48079L39.0854 6.93731C39.2417 8.84844 40.0591 9.59588 41.2427 10.0837C42.5068 8.11442 43.3777 6.34205 43.5385 4.1579L43.5609 3.86251C42.7971 4.26084 42.0378 4.41302 41.3901 4.29665C40.6978 5.23655 39.8894 5.98846 39.0497 6.48079Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9443 31.5851C14.913 31.5851 14.8818 31.5761 14.855 31.5627C14.8014 31.5314 14.7656 31.4732 14.7656 31.4105V27.172C14.7656 27.1094 14.8014 27.0512 14.855 27.0199L16.6996 25.9546C16.7532 25.9233 16.8202 25.9233 16.8783 25.9546C16.9319 25.986 16.9676 26.0442 16.9676 26.1068V30.3453C16.9676 30.408 16.9319 30.4662 16.8783 30.4975L15.0336 31.5627C15.0068 31.5806 14.9756 31.5851 14.9443 31.5851ZM15.1229 27.2705V31.1017L16.6103 30.2424V26.4112L15.1229 27.2705Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8583 29.8934C17.8271 29.8934 17.7958 29.8844 17.769 29.871C17.7154 29.8396 17.6797 29.7815 17.6797 29.7188V21.9445C17.6797 21.8818 17.7154 21.8237 17.769 21.7923L19.6137 20.7271C19.6673 20.6958 19.7343 20.6958 19.7924 20.7271C19.846 20.7584 19.8817 20.8166 19.8817 20.8793V28.6536C19.8817 28.7162 19.846 28.7744 19.7924 28.8058L17.9477 29.871C17.9209 29.8889 17.8896 29.8934 17.8583 29.8934ZM18.037 22.043V29.4055L19.5244 28.5462V21.1836L18.037 22.043Z",
    fill: "#7C1DC9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7802 28.2059C20.749 28.2059 20.7177 28.197 20.6909 28.1836C20.6373 28.1522 20.6016 28.094 20.6016 28.0314V16.7258C20.6016 16.6631 20.6373 16.6049 20.6909 16.5736L22.5356 15.5084C22.5892 15.477 22.6562 15.477 22.7142 15.5084C22.7678 15.5397 22.8036 15.5979 22.8036 15.6605V26.9662C22.8036 27.0288 22.7678 27.087 22.7142 27.1183L20.8696 28.1836C20.8428 28.2015 20.8115 28.2059 20.7802 28.2059ZM20.9589 16.8242V27.7226L22.4462 26.8632V15.9649L20.9589 16.8242Z",
    fill: "#7C1DC9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_2807",
    x1: 85.0396,
    y1: -19.147,
    x2: 52.4185,
    y2: 42.8939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2164_2807",
    x1: 62.6237,
    y1: 43.1816,
    x2: 117.559,
    y2: 13.5258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2164_2807",
    x1: 59.1013,
    y1: 49.2908,
    x2: 82.0712,
    y2: 77.5043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2164_2807",
    x1: 65.3574,
    y1: 48.257,
    x2: 120.293,
    y2: 18.6013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2164_2807",
    x1: 67.468,
    y1: 49.6089,
    x2: 67.4771,
    y2: 49.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2164_2807",
    x1: -2.79605,
    y1: 57.6292,
    x2: 94.1111,
    y2: 35.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2164_2807",
    x1: 68.1788,
    y1: 46.6772,
    x2: 80.0062,
    y2: 46.6772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#712CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7734DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8C4EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6B24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2164_2807",
    x1: 67.3449,
    y1: 41.6866,
    x2: 67.3583,
    y2: 41.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2164_2807",
    x1: 67.5994,
    y1: 41.5705,
    x2: 67.6397,
    y2: 41.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2164_2807",
    x1: 19.0945,
    y1: 42.7251,
    x2: 49.6828,
    y2: 35.8817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2164_2807",
    x1: 38.3979,
    y1: 49.6937,
    x2: 41.4537,
    y2: 49.0116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2164_2807",
    x1: 40.2689,
    y1: 49.5997,
    x2: 40.8541,
    y2: 49.4659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2164_2807",
    x1: 41.0274,
    y1: 49.4616,
    x2: 41.0841,
    y2: 49.4475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2164_2807",
    x1: 48.6022,
    y1: 52.1107,
    x2: 48.6737,
    y2: 52.0928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2164_2807",
    x1: 41.7727,
    y1: 43.2846,
    x2: 52.5192,
    y2: 43.2846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C3ADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7633DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6D27D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9A60EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7734DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.3135 33.8407) scale(3.43923 3.44629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.2551 46.7487) scale(8.44623 8.46355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0668 39.5205) scale(4.73453 4.74424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1082 38.6431) scale(4.31021 4.31905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.0579 47.1912) rotate(90.6487) scale(5.07482 1.22437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4916A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3E128A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2B0D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1B083D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0F0422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#06020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#010003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.7081 39.3767) rotate(90.6487) scale(5.07482 1.22437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4916A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3E128A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2B0D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1B083D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0F0422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#06020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#010003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2164_2807",
    x1: 58.7015,
    y1: -8.35606,
    x2: 22.2538,
    y2: 60.9603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2164_2807",
    x1: 43.0141,
    y1: 50.7949,
    x2: 55.5961,
    y2: 47.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2164_2807",
    x1: 28.6384,
    y1: 62.0961,
    x2: 51.0336,
    y2: 62.0961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1EBFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#23D8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1EBFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#20C6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1AAFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#169BC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#138FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#138BBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2164_2807",
    x1: -23.2215,
    y1: 74.8026,
    x2: 49.7671,
    y2: 58.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2164_2807",
    x1: 26.9485,
    y1: 67.2074,
    x2: 38.8409,
    y2: 85.0519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2164_2807",
    x1: 31.2454,
    y1: 73.6793,
    x2: 36.074,
    y2: 80.9253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4879 61.7066) scale(18.3619 18.3996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.1305 47.5007) scale(2.54593 2.55115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2794 56.6714) scale(8.16483 8.18159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5991 67.1734) rotate(90.6487) scale(5.12647 1.00095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6875 61.5566) rotate(-22.3813) scale(3.14806 6.30529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2164_2807",
    x1: 64.106,
    y1: 54.4379,
    x2: 114.989,
    y2: 54.4379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2164_2807",
    x1: 119.929,
    y1: -3.46432,
    x2: 83.4811,
    y2: 65.8521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2164_2807",
    x1: 90.3421,
    y1: 48.7135,
    x2: 78.3539,
    y2: 48.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2164_2807",
    x1: 99.4656,
    y1: 59.4596,
    x2: 108.841,
    y2: 78.8825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2164_2807",
    x1: 94.338,
    y1: 68.4378,
    x2: 150.189,
    y2: 51.7526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2164_2807",
    x1: 52.7733,
    y1: 62.427,
    x2: 84.8717,
    y2: 55.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2164_2807",
    x1: 76.2103,
    y1: 72.6093,
    x2: 95.5766,
    y2: 68.2759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2164_2807",
    x1: 75.1499,
    y1: 71.1948,
    x2: 84.5295,
    y2: 90.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2164_2807",
    x1: 81.0725,
    y1: 69.5925,
    x2: 67.454,
    y2: 69.5925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.9041 57.2352) scale(5.50724 5.51854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.1501 45.8088) scale(3.96182 3.96995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4335 67.7415) rotate(90.6487) scale(5.74403 1.33567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD3185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8A276A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.6992 69.3911) scale(12.8011 12.8274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.447 63.0133) scale(13.6631 13.6912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2164_2807",
    x1: 84.6974,
    y1: 22.4322,
    x2: 53.3624,
    y2: 82.0271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FEB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2164_2807",
    x1: 34.1094,
    y1: 85.4903,
    x2: 85.1039,
    y2: 85.4903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FCCE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FAC099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FCD4A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9BD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7AE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B695"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2164_2807",
    x1: 24.696,
    y1: 75.335,
    x2: 51.0135,
    y2: 69.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FEB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2164_2807",
    x1: 65.9254,
    y1: 69.2929,
    x2: 50.8999,
    y2: 69.2929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F9B996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FEE1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.7746 69.3464) scale(0.03574 0.035805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.5182 67.5474) scale(2.07247 2.07672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4076 70.3805) scale(2.96132 2.96739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6763 82.4471) scale(19.0275 19.0665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.8646 89.387) rotate(90.6487) scale(4.63624 0.645593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.893 68.8401) rotate(90.6487) scale(4.18353 0.816841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2164_2807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.8277 89.3526) rotate(-22.3913) scale(4.03091 5.12361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_2807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.bd0934b590372f6209ace9abf61e92b6.svg";
export { ForwardRef as ReactComponent };